import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSDate: any;
  AWSDateTime: any;
};




export type Bid = {
  readonly __typename?: 'Bid';
  readonly id: Scalars['ID'];
  readonly version: Scalars['Int'];
  readonly owner: Scalars['ID'];
  readonly bidViewers: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly rfpId: Scalars['ID'];
  readonly rfp: Rfp;
  readonly acceptedIn: Maybe<Rfp>;
  readonly stripeCheckoutSession: Maybe<Scalars['ID']>;
  readonly document: Maybe<File>;
  readonly startDate: Maybe<Scalars['AWSDate']>;
  readonly items: ReadonlyArray<BidLineItem>;
  readonly bidder: Maybe<Profile>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
};

export type BidLineItem = {
  readonly __typename?: 'BidLineItem';
  readonly name: Scalars['String'];
  readonly price: Scalars['Float'];
};

export type BidLineItemInput = {
  readonly name: Scalars['String'];
  readonly price: Scalars['Float'];
};

export type BidRequest = {
  readonly __typename?: 'BidRequest';
  readonly id: Scalars['ID'];
  readonly version: Scalars['Int'];
  readonly requestedEmail: Scalars['String'];
  readonly rfpId: Scalars['ID'];
  readonly rfp: Rfp;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
  readonly owner: Maybe<Scalars['String']>;
};

export type ComparableProperty = {
  readonly __typename?: 'ComparableProperty';
  /** The ID of this comparison record. Not the ID of the property behind the data */
  readonly id: Scalars['ID'];
  readonly propertyId: Scalars['ID'];
  readonly expenses: Maybe<ModelExpensesConnection>;
  readonly measurements: Maybe<ModelMeasurementsConnection>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
  readonly version: Scalars['Int'];
  readonly owner: Maybe<Scalars['String']>;
};


export type ComparablePropertyExpensesArgs = {
  date: Maybe<ModelStringKeyConditionInput>;
  filter: Maybe<ModelExpensesFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type ComparablePropertyMeasurementsArgs = {
  date: Maybe<ModelStringKeyConditionInput>;
  filter: Maybe<ModelMeasurementsFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};

export type CostLineItem = {
  readonly __typename?: 'CostLineItem';
  readonly name: Scalars['String'];
  readonly price: Scalars['Float'];
  readonly schedule: CostSchedule;
};

export type CostLineItemInput = {
  readonly name: Scalars['String'];
  readonly price: Scalars['Float'];
  readonly schedule: CostSchedule;
};

export enum CostSchedule {
  OneTime = 'ONE_TIME',
  Annual = 'ANNUAL'
}

export type CreateBidInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly owner: Scalars['ID'];
  readonly bidViewers?: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly rfpId: Scalars['ID'];
  readonly stripeCheckoutSession?: Maybe<Scalars['ID']>;
  readonly document?: Maybe<FileInput>;
  readonly startDate?: Maybe<Scalars['AWSDate']>;
  readonly items: ReadonlyArray<BidLineItemInput>;
  readonly acceptedBidId?: Maybe<Scalars['ID']>;
};

export type CreateBidRequestInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly requestedEmail: Scalars['String'];
  readonly rfpId: Scalars['ID'];
};

export type CreateComparablePropertyInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly propertyId: Scalars['ID'];
};

export type CreateExpensesInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly propertyId: Scalars['ID'];
  readonly date: Scalars['AWSDateTime'];
  readonly analysis?: Maybe<ExpenseAnalysisInput>;
  readonly lineItems: ReadonlyArray<ExpenseLineItemInput>;
};

export type CreateMeasurementsInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly propertyId: Scalars['ID'];
  readonly date: Scalars['AWSDateTime'];
  readonly values?: Maybe<ReadonlyArray<MeasurementInput>>;
  readonly photos?: Maybe<ReadonlyArray<PhotoInput>>;
};

export type CreateOrLinkUserResponse = {
  readonly __typename?: 'CreateOrLinkUserResponse';
  readonly username: Scalars['String'];
  readonly token: Maybe<Scalars['String']>;
};

export type CreateProfileInput = {
  readonly username: Scalars['ID'];
  readonly name?: Maybe<Scalars['String']>;
  readonly companyName?: Maybe<Scalars['String']>;
  readonly photo?: Maybe<FileInput>;
  readonly companyLogo?: Maybe<FileInput>;
  readonly persona?: Maybe<Persona>;
  readonly agreedToTermsOfUse?: Maybe<Scalars['Boolean']>;
  readonly termsOfUseVersion?: Maybe<Scalars['String']>;
};

export type CreatePropertyInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly owner?: Maybe<Scalars['ID']>;
  readonly name: Scalars['String'];
  readonly address?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly zipcode?: Maybe<Scalars['String']>;
  readonly photo?: Maybe<FileInput>;
  readonly type?: Maybe<Scalars['String']>;
  readonly class?: Maybe<Scalars['String']>;
};

export type CreateRfpInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly due?: Maybe<Scalars['AWSDate']>;
  readonly state: RfpState;
  readonly scope?: Maybe<ScopeInput>;
  readonly type?: Maybe<RfpType>;
  readonly subType?: Maybe<Scalars['String']>;
  readonly owner?: Maybe<Scalars['String']>;
  readonly propertyId: Scalars['ID'];
  readonly acceptedBidId?: Maybe<Scalars['ID']>;
  readonly measurementData?: Maybe<ReadonlyArray<MeasurementInput>>;
  readonly measurementPhoto?: Maybe<FileInput>;
  readonly notes?: Maybe<ReadonlyArray<NotePartInput>>;
};

export type CreateServiceContractInput = {
  readonly id?: Maybe<Scalars['ID']>;
  readonly owner?: Maybe<Scalars['String']>;
  readonly propertyId: Scalars['ID'];
  readonly start: Scalars['AWSDate'];
  readonly end?: Maybe<Scalars['AWSDate']>;
  readonly type: ServiceType;
  readonly scope?: Maybe<ScopeInput>;
  readonly measurementsId: Scalars['ID'];
  readonly costs: ReadonlyArray<CostLineItemInput>;
  readonly notes?: Maybe<ReadonlyArray<NotePartInput>>;
};

export type DeleteBidInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteBidRequestInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteComparablePropertyInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteExpensesInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteMeasurementsInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteProfileInput = {
  readonly username: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeletePropertyInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteRfpInput = {
  readonly id: Scalars['ID'];
  readonly expectedVersion: Scalars['Int'];
};

export type DeleteServiceContractInput = {
  readonly id: Scalars['ID'];
};

export type ExpenseAnalysis = {
  readonly __typename?: 'ExpenseAnalysis';
  readonly costPercentage: Scalars['Float'];
};

export type ExpenseAnalysisInput = {
  readonly costPercentage: Scalars['Float'];
};

export type ExpenseLineItem = {
  readonly __typename?: 'ExpenseLineItem';
  readonly name: Scalars['String'];
  readonly amount: Maybe<Scalars['Float']>;
  readonly breakdown: ReadonlyArray<ExpenseLineItemDetail>;
  readonly analysis: Maybe<ExpenseAnalysis>;
};

export type ExpenseLineItemDetail = {
  readonly __typename?: 'ExpenseLineItemDetail';
  readonly name: Scalars['String'];
  readonly amount: Scalars['Float'];
};

export type ExpenseLineItemDetailInput = {
  readonly name: Scalars['String'];
  readonly amount: Scalars['Float'];
};

export type ExpenseLineItemInput = {
  readonly name: Scalars['String'];
  readonly amount?: Maybe<Scalars['Float']>;
  readonly breakdown: ReadonlyArray<ExpenseLineItemDetailInput>;
  readonly analysis?: Maybe<ExpenseAnalysisInput>;
};

export type Expenses = {
  readonly __typename?: 'Expenses';
  readonly id: Scalars['ID'];
  readonly propertyId: Scalars['ID'];
  readonly property: Property;
  readonly date: Scalars['AWSDateTime'];
  readonly analysis: Maybe<ExpenseAnalysis>;
  readonly lineItems: ReadonlyArray<ExpenseLineItem>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
  readonly version: Scalars['Int'];
  readonly owner: Maybe<Scalars['String']>;
};

export type File = {
  readonly __typename?: 'File';
  readonly path: Scalars['String'];
  readonly identityId: Scalars['String'];
};

export type FileInput = {
  readonly path: Scalars['String'];
  readonly identityId: Scalars['String'];
};

export type Measurement = {
  readonly __typename?: 'Measurement';
  readonly label: Scalars['String'];
  readonly unit: Maybe<Scalars['String']>;
  readonly value: Maybe<Scalars['String']>;
  readonly breakdown: Maybe<ReadonlyArray<Measurement>>;
};

export type MeasurementInput = {
  readonly label: Scalars['String'];
  readonly unit?: Maybe<Scalars['String']>;
  readonly value?: Maybe<Scalars['String']>;
  readonly breakdown?: Maybe<ReadonlyArray<MeasurementInput>>;
};

export type Measurements = {
  readonly __typename?: 'Measurements';
  readonly id: Scalars['ID'];
  readonly propertyId: Scalars['ID'];
  readonly property: Property;
  readonly date: Scalars['AWSDateTime'];
  readonly values: Maybe<ReadonlyArray<Measurement>>;
  readonly photos: Maybe<ReadonlyArray<Photo>>;
  readonly serviceContracts: Maybe<ModelServiceContractConnection>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
  readonly version: Scalars['Int'];
  readonly owner: Maybe<Scalars['String']>;
};


export type MeasurementsServiceContractsArgs = {
  filter: Maybe<ModelServiceContractFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};

export type ModelBidConnection = {
  readonly __typename?: 'ModelBidConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<Bid>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelBidFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly version?: Maybe<ModelIntFilterInput>;
  readonly owner?: Maybe<ModelIdFilterInput>;
  readonly bidViewers?: Maybe<ModelIdFilterInput>;
  readonly rfpId?: Maybe<ModelIdFilterInput>;
  readonly stripeCheckoutSession?: Maybe<ModelIdFilterInput>;
  readonly startDate?: Maybe<ModelStringFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelBidFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelBidFilterInput>>>;
  readonly not?: Maybe<ModelBidFilterInput>;
};

export type ModelBidRequestConnection = {
  readonly __typename?: 'ModelBidRequestConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<BidRequest>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelBidRequestFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly version?: Maybe<ModelIntFilterInput>;
  readonly requestedEmail?: Maybe<ModelStringFilterInput>;
  readonly rfpId?: Maybe<ModelIdFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelBidRequestFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelBidRequestFilterInput>>>;
  readonly not?: Maybe<ModelBidRequestFilterInput>;
};

export type ModelBooleanFilterInput = {
  readonly ne?: Maybe<Scalars['Boolean']>;
  readonly eq?: Maybe<Scalars['Boolean']>;
};

export type ModelComparablePropertyConnection = {
  readonly __typename?: 'ModelComparablePropertyConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<ComparableProperty>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelComparablePropertyFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly propertyId?: Maybe<ModelIdFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelComparablePropertyFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelComparablePropertyFilterInput>>>;
  readonly not?: Maybe<ModelComparablePropertyFilterInput>;
};

export type ModelExpensesConnection = {
  readonly __typename?: 'ModelExpensesConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<Expenses>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelExpensesFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly propertyId?: Maybe<ModelIdFilterInput>;
  readonly date?: Maybe<ModelStringFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelExpensesFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelExpensesFilterInput>>>;
  readonly not?: Maybe<ModelExpensesFilterInput>;
};

export type ModelFloatFilterInput = {
  readonly ne?: Maybe<Scalars['Float']>;
  readonly eq?: Maybe<Scalars['Float']>;
  readonly le?: Maybe<Scalars['Float']>;
  readonly lt?: Maybe<Scalars['Float']>;
  readonly ge?: Maybe<Scalars['Float']>;
  readonly gt?: Maybe<Scalars['Float']>;
  readonly between?: Maybe<ReadonlyArray<Maybe<Scalars['Float']>>>;
};

export type ModelIdFilterInput = {
  readonly ne?: Maybe<Scalars['ID']>;
  readonly eq?: Maybe<Scalars['ID']>;
  readonly le?: Maybe<Scalars['ID']>;
  readonly lt?: Maybe<Scalars['ID']>;
  readonly ge?: Maybe<Scalars['ID']>;
  readonly gt?: Maybe<Scalars['ID']>;
  readonly contains?: Maybe<Scalars['ID']>;
  readonly notContains?: Maybe<Scalars['ID']>;
  readonly between?: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly beginsWith?: Maybe<Scalars['ID']>;
};

export type ModelIntFilterInput = {
  readonly ne?: Maybe<Scalars['Int']>;
  readonly eq?: Maybe<Scalars['Int']>;
  readonly le?: Maybe<Scalars['Int']>;
  readonly lt?: Maybe<Scalars['Int']>;
  readonly ge?: Maybe<Scalars['Int']>;
  readonly gt?: Maybe<Scalars['Int']>;
  readonly between?: Maybe<ReadonlyArray<Maybe<Scalars['Int']>>>;
};

export type ModelMeasurementsConnection = {
  readonly __typename?: 'ModelMeasurementsConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<Measurements>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelMeasurementsFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly propertyId?: Maybe<ModelIdFilterInput>;
  readonly date?: Maybe<ModelStringFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelMeasurementsFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelMeasurementsFilterInput>>>;
  readonly not?: Maybe<ModelMeasurementsFilterInput>;
};

export type ModelPersonaFilterInput = {
  readonly eq?: Maybe<Persona>;
  readonly ne?: Maybe<Persona>;
};

export type ModelPropertyConnection = {
  readonly __typename?: 'ModelPropertyConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<Property>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelPropertyFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly version?: Maybe<ModelIntFilterInput>;
  readonly owner?: Maybe<ModelIdFilterInput>;
  readonly name?: Maybe<ModelStringFilterInput>;
  readonly address?: Maybe<ModelStringFilterInput>;
  readonly city?: Maybe<ModelStringFilterInput>;
  readonly state?: Maybe<ModelStringFilterInput>;
  readonly zipcode?: Maybe<ModelStringFilterInput>;
  readonly type?: Maybe<ModelStringFilterInput>;
  readonly class?: Maybe<ModelStringFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelPropertyFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelPropertyFilterInput>>>;
  readonly not?: Maybe<ModelPropertyFilterInput>;
};

export type ModelRfpConnection = {
  readonly __typename?: 'ModelRFPConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<Rfp>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelRfpFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly version?: Maybe<ModelIntFilterInput>;
  readonly title?: Maybe<ModelStringFilterInput>;
  readonly due?: Maybe<ModelStringFilterInput>;
  readonly state?: Maybe<ModelRfpStateFilterInput>;
  readonly type?: Maybe<ModelRfpTypeFilterInput>;
  readonly subType?: Maybe<ModelStringFilterInput>;
  readonly owner?: Maybe<ModelStringFilterInput>;
  readonly propertyId?: Maybe<ModelIdFilterInput>;
  readonly acceptedBidId?: Maybe<ModelIdFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelRfpFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelRfpFilterInput>>>;
  readonly not?: Maybe<ModelRfpFilterInput>;
};

export type ModelRfpStateFilterInput = {
  readonly eq?: Maybe<RfpState>;
  readonly ne?: Maybe<RfpState>;
};

export type ModelRfpTypeFilterInput = {
  readonly eq?: Maybe<RfpType>;
  readonly ne?: Maybe<RfpType>;
};

export type ModelServiceContractBy_PropertyCompositeKeyConditionInput = {
  readonly eq?: Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>;
  readonly le?: Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>;
  readonly lt?: Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>;
  readonly ge?: Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>;
  readonly gt?: Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>;
  readonly between?: Maybe<ReadonlyArray<Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>>>;
  readonly beginsWith?: Maybe<ModelServiceContractBy_PropertyCompositeKeyInput>;
};

export type ModelServiceContractBy_PropertyCompositeKeyInput = {
  readonly type?: Maybe<ServiceType>;
  readonly start?: Maybe<Scalars['String']>;
};

export type ModelServiceContractConnection = {
  readonly __typename?: 'ModelServiceContractConnection';
  readonly items: Maybe<ReadonlyArray<Maybe<ServiceContract>>>;
  readonly nextToken: Maybe<Scalars['String']>;
};

export type ModelServiceContractFilterInput = {
  readonly id?: Maybe<ModelIdFilterInput>;
  readonly owner?: Maybe<ModelStringFilterInput>;
  readonly propertyId?: Maybe<ModelIdFilterInput>;
  readonly start?: Maybe<ModelStringFilterInput>;
  readonly end?: Maybe<ModelStringFilterInput>;
  readonly type?: Maybe<ModelServiceTypeFilterInput>;
  readonly measurementsId?: Maybe<ModelIdFilterInput>;
  readonly and?: Maybe<ReadonlyArray<Maybe<ModelServiceContractFilterInput>>>;
  readonly or?: Maybe<ReadonlyArray<Maybe<ModelServiceContractFilterInput>>>;
  readonly not?: Maybe<ModelServiceContractFilterInput>;
};

export type ModelServiceTypeFilterInput = {
  readonly eq?: Maybe<ServiceType>;
  readonly ne?: Maybe<ServiceType>;
};

export enum ModelSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ModelStringFilterInput = {
  readonly ne?: Maybe<Scalars['String']>;
  readonly eq?: Maybe<Scalars['String']>;
  readonly le?: Maybe<Scalars['String']>;
  readonly lt?: Maybe<Scalars['String']>;
  readonly ge?: Maybe<Scalars['String']>;
  readonly gt?: Maybe<Scalars['String']>;
  readonly contains?: Maybe<Scalars['String']>;
  readonly notContains?: Maybe<Scalars['String']>;
  readonly between?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly beginsWith?: Maybe<Scalars['String']>;
};

export type ModelStringKeyConditionInput = {
  readonly eq?: Maybe<Scalars['String']>;
  readonly le?: Maybe<Scalars['String']>;
  readonly lt?: Maybe<Scalars['String']>;
  readonly ge?: Maybe<Scalars['String']>;
  readonly gt?: Maybe<Scalars['String']>;
  readonly between?: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly beginsWith?: Maybe<Scalars['String']>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly startStripeCheckoutSessionForBid: StripeCheckout;
  readonly createOrLinkUser: CreateOrLinkUserResponse;
  readonly createBid: Maybe<Bid>;
  readonly updateBid: Maybe<Bid>;
  readonly deleteBid: Maybe<Bid>;
  readonly createProfile: Maybe<Profile>;
  readonly updateProfile: Maybe<Profile>;
  readonly deleteProfile: Maybe<Profile>;
  readonly createComparableProperty: Maybe<ComparableProperty>;
  readonly updateComparableProperty: Maybe<ComparableProperty>;
  readonly deleteComparableProperty: Maybe<ComparableProperty>;
  readonly createProperty: Maybe<Property>;
  readonly updateProperty: Maybe<Property>;
  readonly deleteProperty: Maybe<Property>;
  readonly createServiceContract: Maybe<ServiceContract>;
  readonly updateServiceContract: Maybe<ServiceContract>;
  readonly deleteServiceContract: Maybe<ServiceContract>;
  readonly createExpenses: Maybe<Expenses>;
  readonly updateExpenses: Maybe<Expenses>;
  readonly deleteExpenses: Maybe<Expenses>;
  readonly createMeasurements: Maybe<Measurements>;
  readonly updateMeasurements: Maybe<Measurements>;
  readonly deleteMeasurements: Maybe<Measurements>;
  readonly createBidRequest: Maybe<BidRequest>;
  readonly updateBidRequest: Maybe<BidRequest>;
  readonly deleteBidRequest: Maybe<BidRequest>;
  readonly createRFP: Maybe<Rfp>;
  readonly updateRFP: Maybe<Rfp>;
  readonly deleteRFP: Maybe<Rfp>;
};


export type MutationStartStripeCheckoutSessionForBidArgs = {
  bidId: Scalars['ID'];
  description: Maybe<Scalars['String']>;
};


export type MutationCreateBidArgs = {
  input: CreateBidInput;
};


export type MutationUpdateBidArgs = {
  input: UpdateBidInput;
};


export type MutationDeleteBidArgs = {
  input: DeleteBidInput;
};


export type MutationCreateProfileArgs = {
  input: CreateProfileInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationDeleteProfileArgs = {
  input: DeleteProfileInput;
};


export type MutationCreateComparablePropertyArgs = {
  input: CreateComparablePropertyInput;
};


export type MutationUpdateComparablePropertyArgs = {
  input: UpdateComparablePropertyInput;
};


export type MutationDeleteComparablePropertyArgs = {
  input: DeleteComparablePropertyInput;
};


export type MutationCreatePropertyArgs = {
  input: CreatePropertyInput;
};


export type MutationUpdatePropertyArgs = {
  input: UpdatePropertyInput;
};


export type MutationDeletePropertyArgs = {
  input: DeletePropertyInput;
};


export type MutationCreateServiceContractArgs = {
  input: CreateServiceContractInput;
};


export type MutationUpdateServiceContractArgs = {
  input: UpdateServiceContractInput;
};


export type MutationDeleteServiceContractArgs = {
  input: DeleteServiceContractInput;
};


export type MutationCreateExpensesArgs = {
  input: CreateExpensesInput;
};


export type MutationUpdateExpensesArgs = {
  input: UpdateExpensesInput;
};


export type MutationDeleteExpensesArgs = {
  input: DeleteExpensesInput;
};


export type MutationCreateMeasurementsArgs = {
  input: CreateMeasurementsInput;
};


export type MutationUpdateMeasurementsArgs = {
  input: UpdateMeasurementsInput;
};


export type MutationDeleteMeasurementsArgs = {
  input: DeleteMeasurementsInput;
};


export type MutationCreateBidRequestArgs = {
  input: CreateBidRequestInput;
};


export type MutationUpdateBidRequestArgs = {
  input: UpdateBidRequestInput;
};


export type MutationDeleteBidRequestArgs = {
  input: DeleteBidRequestInput;
};


export type MutationCreateRfpArgs = {
  input: CreateRfpInput;
};


export type MutationUpdateRfpArgs = {
  input: UpdateRfpInput;
};


export type MutationDeleteRfpArgs = {
  input: DeleteRfpInput;
};

export type NotePart = {
  readonly __typename?: 'NotePart';
  readonly id: Scalars['String'];
  readonly type: NotePartType;
  readonly text: Maybe<Scalars['String']>;
  readonly photo: Maybe<File>;
};

export type NotePartInput = {
  readonly id: Scalars['String'];
  readonly type: NotePartType;
  readonly text?: Maybe<Scalars['String']>;
  readonly photo?: Maybe<FileInput>;
};

export enum NotePartType {
  Text = 'TEXT',
  Photo = 'PHOTO'
}

export enum Persona {
  PropertyManager = 'PROPERTY_MANAGER',
  ServiceProvider = 'SERVICE_PROVIDER',
  Metrologist = 'METROLOGIST'
}

export type Photo = {
  readonly __typename?: 'Photo';
  readonly label: Scalars['String'];
  readonly file: File;
};

export type PhotoInput = {
  readonly label: Scalars['String'];
  readonly file: FileInput;
};

export type Profile = {
  readonly __typename?: 'Profile';
  readonly username: Scalars['ID'];
  readonly version: Scalars['Int'];
  readonly name: Maybe<Scalars['String']>;
  readonly companyName: Maybe<Scalars['String']>;
  readonly photo: Maybe<File>;
  readonly companyLogo: Maybe<File>;
  readonly persona: Maybe<Persona>;
  readonly agreedToTermsOfUse: Maybe<Scalars['Boolean']>;
  readonly termsOfUseVersion: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
};

export type Property = {
  readonly __typename?: 'Property';
  readonly id: Scalars['ID'];
  readonly version: Scalars['Int'];
  readonly owner: Maybe<Scalars['ID']>;
  readonly name: Scalars['String'];
  readonly address: Maybe<Scalars['String']>;
  readonly city: Maybe<Scalars['String']>;
  readonly state: Maybe<Scalars['String']>;
  readonly zipcode: Maybe<Scalars['String']>;
  readonly photo: Maybe<File>;
  readonly rfps: Maybe<ModelRfpConnection>;
  readonly measurements: Maybe<ModelMeasurementsConnection>;
  readonly expenses: Maybe<ModelExpensesConnection>;
  readonly comparableProperties: Maybe<ModelComparablePropertyConnection>;
  readonly type: Maybe<Scalars['String']>;
  readonly class: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
};


export type PropertyRfpsArgs = {
  filter: Maybe<ModelRfpFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type PropertyMeasurementsArgs = {
  date: Maybe<ModelStringKeyConditionInput>;
  filter: Maybe<ModelMeasurementsFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type PropertyExpensesArgs = {
  date: Maybe<ModelStringKeyConditionInput>;
  filter: Maybe<ModelExpensesFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type PropertyComparablePropertiesArgs = {
  filter: Maybe<ModelComparablePropertyFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly bid: Maybe<Bid>;
  readonly bids: Maybe<ModelBidConnection>;
  readonly profile: Maybe<Profile>;
  readonly property: Maybe<Property>;
  readonly properties: Maybe<ModelPropertyConnection>;
  readonly serviceContract: Maybe<ServiceContract>;
  readonly expenses: Maybe<Expenses>;
  readonly measurements: Maybe<Measurements>;
  readonly bidRequest: Maybe<BidRequest>;
  readonly rfp: Maybe<Rfp>;
  readonly rfps: Maybe<ModelRfpConnection>;
  readonly comparablePropertiesForProperty: Maybe<ModelComparablePropertyConnection>;
  readonly serviceContractsByMeasurements: Maybe<ModelServiceContractConnection>;
  readonly serviceContractsForProperty: Maybe<ModelServiceContractConnection>;
  readonly expensesForProperty: Maybe<ModelExpensesConnection>;
  readonly measurementsForProperty: Maybe<ModelMeasurementsConnection>;
  readonly bidRequestsByEmail: Maybe<ModelBidRequestConnection>;
  readonly rfpsByState: Maybe<ModelRfpConnection>;
};


export type QueryBidArgs = {
  id: Scalars['ID'];
};


export type QueryBidsArgs = {
  filter: Maybe<ModelBidFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryProfileArgs = {
  username: Scalars['ID'];
};


export type QueryPropertyArgs = {
  id: Scalars['ID'];
};


export type QueryPropertiesArgs = {
  filter: Maybe<ModelPropertyFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryServiceContractArgs = {
  id: Scalars['ID'];
};


export type QueryExpensesArgs = {
  id: Scalars['ID'];
};


export type QueryMeasurementsArgs = {
  id: Scalars['ID'];
};


export type QueryBidRequestArgs = {
  id: Scalars['ID'];
};


export type QueryRfpArgs = {
  id: Scalars['ID'];
};


export type QueryRfpsArgs = {
  filter: Maybe<ModelRfpFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryComparablePropertiesForPropertyArgs = {
  propertyId: Maybe<Scalars['ID']>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelComparablePropertyFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryServiceContractsByMeasurementsArgs = {
  measurementsId: Maybe<Scalars['ID']>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelServiceContractFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryServiceContractsForPropertyArgs = {
  propertyId: Maybe<Scalars['ID']>;
  typeStart: Maybe<ModelServiceContractBy_PropertyCompositeKeyConditionInput>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelServiceContractFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryExpensesForPropertyArgs = {
  propertyId: Maybe<Scalars['ID']>;
  date: Maybe<ModelStringKeyConditionInput>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelExpensesFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryMeasurementsForPropertyArgs = {
  propertyId: Maybe<Scalars['ID']>;
  date: Maybe<ModelStringKeyConditionInput>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelMeasurementsFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryBidRequestsByEmailArgs = {
  requestedEmail: Maybe<Scalars['String']>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelBidRequestFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type QueryRfpsByStateArgs = {
  state: Maybe<RfpState>;
  sortDirection: Maybe<ModelSortDirection>;
  filter: Maybe<ModelRfpFilterInput>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};

export type Rfp = {
  readonly __typename?: 'RFP';
  readonly id: Scalars['ID'];
  readonly version: Scalars['Int'];
  readonly title: Maybe<Scalars['String']>;
  readonly due: Maybe<Scalars['AWSDate']>;
  readonly state: RfpState;
  readonly scope: Maybe<Scope>;
  readonly type: Maybe<RfpType>;
  readonly subType: Maybe<Scalars['String']>;
  readonly owner: Maybe<Scalars['String']>;
  readonly propertyId: Scalars['ID'];
  readonly property: Maybe<Property>;
  readonly bids: Maybe<ModelBidConnection>;
  readonly bidRequests: Maybe<ModelBidRequestConnection>;
  readonly acceptedBidId: Maybe<Scalars['ID']>;
  readonly acceptedBid: Bid;
  readonly measurementData: Maybe<ReadonlyArray<Measurement>>;
  readonly measurementPhoto: Maybe<File>;
  readonly notes: Maybe<ReadonlyArray<NotePart>>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
};


export type RfpBidsArgs = {
  filter: Maybe<ModelBidFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};


export type RfpBidRequestsArgs = {
  filter: Maybe<ModelBidRequestFilterInput>;
  sortDirection: Maybe<ModelSortDirection>;
  limit: Maybe<Scalars['Int']>;
  nextToken: Maybe<Scalars['String']>;
};

export enum RfpState {
  NeedsMeasurement = 'NEEDS_MEASUREMENT',
  MeasurementsReady = 'MEASUREMENTS_READY',
  Open = 'OPEN',
  Closed = 'CLOSED'
}

export enum RfpType {
  Landscape = 'LANDSCAPE',
  Custom = 'CUSTOM'
}

export type Scope = {
  readonly __typename?: 'Scope';
  readonly services: Maybe<ReadonlyArray<Service>>;
};

export type ScopeInput = {
  readonly services?: Maybe<ReadonlyArray<ServiceInput>>;
};

export type Service = {
  readonly __typename?: 'Service';
  readonly label: Scalars['String'];
  readonly facets: ReadonlyArray<ServiceFacet>;
  readonly schedule: ServiceSchedule;
};

export type ServiceContract = {
  readonly __typename?: 'ServiceContract';
  readonly id: Scalars['ID'];
  readonly owner: Maybe<Scalars['String']>;
  readonly propertyId: Scalars['ID'];
  readonly property: Maybe<Property>;
  readonly start: Scalars['AWSDate'];
  readonly end: Maybe<Scalars['AWSDate']>;
  readonly type: ServiceType;
  readonly scope: Maybe<Scope>;
  readonly measurementsId: Scalars['ID'];
  readonly measurements: Maybe<Measurements>;
  readonly costs: ReadonlyArray<CostLineItem>;
  readonly notes: Maybe<ReadonlyArray<NotePart>>;
  readonly createdAt: Scalars['AWSDateTime'];
  readonly updatedAt: Scalars['AWSDateTime'];
};

export type ServiceFacet = {
  readonly __typename?: 'ServiceFacet';
  readonly label: Scalars['String'];
  readonly schedule: ServiceSchedule;
};

export type ServiceFacetInput = {
  readonly label: Scalars['String'];
  readonly schedule: ServiceScheduleInput;
};

export type ServiceInput = {
  readonly label: Scalars['String'];
  readonly facets: ReadonlyArray<ServiceFacetInput>;
  readonly schedule: ServiceScheduleInput;
};

export type ServiceSchedule = {
  readonly __typename?: 'ServiceSchedule';
  readonly label: Scalars['String'];
  readonly chosenFrom: ReadonlyArray<Scalars['String']>;
  readonly disableChoice: Scalars['String'];
};

export type ServiceScheduleInput = {
  readonly label: Scalars['String'];
  readonly chosenFrom: ReadonlyArray<Scalars['String']>;
  readonly disableChoice: Scalars['String'];
};

export enum ServiceType {
  Landscaping = 'LANDSCAPING',
  Janitorial = 'JANITORIAL',
  Waste = 'WASTE',
  Windows = 'WINDOWS',
  Security = 'SECURITY',
  Elevators = 'ELEVATORS',
  Hvac = 'HVAC'
}

export type StripeCheckout = {
  readonly __typename?: 'StripeCheckout';
  readonly sessionId: Scalars['String'];
};

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly onCreateBid: Maybe<Bid>;
  readonly onUpdateBid: Maybe<Bid>;
  readonly onDeleteBid: Maybe<Bid>;
  readonly onCreateProfile: Maybe<Profile>;
  readonly onUpdateProfile: Maybe<Profile>;
  readonly onDeleteProfile: Maybe<Profile>;
  readonly onCreateComparableProperty: Maybe<ComparableProperty>;
  readonly onUpdateComparableProperty: Maybe<ComparableProperty>;
  readonly onDeleteComparableProperty: Maybe<ComparableProperty>;
  readonly onCreateProperty: Maybe<Property>;
  readonly onUpdateProperty: Maybe<Property>;
  readonly onDeleteProperty: Maybe<Property>;
  readonly onCreateServiceContract: Maybe<ServiceContract>;
  readonly onUpdateServiceContract: Maybe<ServiceContract>;
  readonly onDeleteServiceContract: Maybe<ServiceContract>;
  readonly onCreateExpenses: Maybe<Expenses>;
  readonly onUpdateExpenses: Maybe<Expenses>;
  readonly onDeleteExpenses: Maybe<Expenses>;
  readonly onCreateMeasurements: Maybe<Measurements>;
  readonly onUpdateMeasurements: Maybe<Measurements>;
  readonly onDeleteMeasurements: Maybe<Measurements>;
  readonly onCreateBidRequest: Maybe<BidRequest>;
  readonly onUpdateBidRequest: Maybe<BidRequest>;
  readonly onDeleteBidRequest: Maybe<BidRequest>;
  readonly onCreateRFP: Maybe<Rfp>;
  readonly onUpdateRFP: Maybe<Rfp>;
  readonly onDeleteRFP: Maybe<Rfp>;
};


export type SubscriptionOnCreateBidArgs = {
  owner: Maybe<Scalars['String']>;
  bidViewers: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateBidArgs = {
  owner: Maybe<Scalars['String']>;
  bidViewers: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeleteBidArgs = {
  owner: Maybe<Scalars['String']>;
  bidViewers: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreateProfileArgs = {
  username: Scalars['String'];
};


export type SubscriptionOnUpdateProfileArgs = {
  username: Scalars['String'];
};


export type SubscriptionOnDeleteProfileArgs = {
  username: Scalars['String'];
};


export type SubscriptionOnCreateComparablePropertyArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateComparablePropertyArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeleteComparablePropertyArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreatePropertyArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdatePropertyArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeletePropertyArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreateServiceContractArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateServiceContractArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeleteServiceContractArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreateExpensesArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateExpensesArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeleteExpensesArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreateMeasurementsArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateMeasurementsArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeleteMeasurementsArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnCreateBidRequestArgs = {
  owner: Scalars['String'];
  requestedEmail: Scalars['String'];
};


export type SubscriptionOnUpdateBidRequestArgs = {
  owner: Scalars['String'];
  requestedEmail: Scalars['String'];
};


export type SubscriptionOnDeleteBidRequestArgs = {
  owner: Scalars['String'];
  requestedEmail: Scalars['String'];
};


export type SubscriptionOnCreateRfpArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnUpdateRfpArgs = {
  owner: Maybe<Scalars['String']>;
};


export type SubscriptionOnDeleteRfpArgs = {
  owner: Maybe<Scalars['String']>;
};

export type UpdateBidInput = {
  readonly id: Scalars['ID'];
  readonly version?: Maybe<Scalars['Int']>;
  readonly owner?: Maybe<Scalars['ID']>;
  readonly bidViewers?: Maybe<ReadonlyArray<Maybe<Scalars['ID']>>>;
  readonly rfpId?: Maybe<Scalars['ID']>;
  readonly stripeCheckoutSession?: Maybe<Scalars['ID']>;
  readonly document?: Maybe<FileInput>;
  readonly startDate?: Maybe<Scalars['AWSDate']>;
  readonly items?: Maybe<ReadonlyArray<BidLineItemInput>>;
  readonly expectedVersion: Scalars['Int'];
  readonly acceptedBidId?: Maybe<Scalars['ID']>;
};

export type UpdateBidRequestInput = {
  readonly id: Scalars['ID'];
  readonly version?: Maybe<Scalars['Int']>;
  readonly requestedEmail?: Maybe<Scalars['String']>;
  readonly rfpId?: Maybe<Scalars['ID']>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdateComparablePropertyInput = {
  readonly id: Scalars['ID'];
  readonly propertyId?: Maybe<Scalars['ID']>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdateExpensesInput = {
  readonly id: Scalars['ID'];
  readonly propertyId?: Maybe<Scalars['ID']>;
  readonly date?: Maybe<Scalars['AWSDateTime']>;
  readonly analysis?: Maybe<ExpenseAnalysisInput>;
  readonly lineItems?: Maybe<ReadonlyArray<ExpenseLineItemInput>>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdateMeasurementsInput = {
  readonly id: Scalars['ID'];
  readonly propertyId?: Maybe<Scalars['ID']>;
  readonly date?: Maybe<Scalars['AWSDateTime']>;
  readonly values?: Maybe<ReadonlyArray<MeasurementInput>>;
  readonly photos?: Maybe<ReadonlyArray<PhotoInput>>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdateProfileInput = {
  readonly username: Scalars['ID'];
  readonly version?: Maybe<Scalars['Int']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly companyName?: Maybe<Scalars['String']>;
  readonly photo?: Maybe<FileInput>;
  readonly companyLogo?: Maybe<FileInput>;
  readonly persona?: Maybe<Persona>;
  readonly agreedToTermsOfUse?: Maybe<Scalars['Boolean']>;
  readonly termsOfUseVersion?: Maybe<Scalars['String']>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdatePropertyInput = {
  readonly id: Scalars['ID'];
  readonly version?: Maybe<Scalars['Int']>;
  readonly owner?: Maybe<Scalars['ID']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly address?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly zipcode?: Maybe<Scalars['String']>;
  readonly photo?: Maybe<FileInput>;
  readonly type?: Maybe<Scalars['String']>;
  readonly class?: Maybe<Scalars['String']>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdateRfpInput = {
  readonly id: Scalars['ID'];
  readonly version?: Maybe<Scalars['Int']>;
  readonly title?: Maybe<Scalars['String']>;
  readonly due?: Maybe<Scalars['AWSDate']>;
  readonly state?: Maybe<RfpState>;
  readonly scope?: Maybe<ScopeInput>;
  readonly type?: Maybe<RfpType>;
  readonly subType?: Maybe<Scalars['String']>;
  readonly owner?: Maybe<Scalars['String']>;
  readonly propertyId?: Maybe<Scalars['ID']>;
  readonly acceptedBidId?: Maybe<Scalars['ID']>;
  readonly measurementData?: Maybe<ReadonlyArray<MeasurementInput>>;
  readonly measurementPhoto?: Maybe<FileInput>;
  readonly notes?: Maybe<ReadonlyArray<NotePartInput>>;
  readonly expectedVersion: Scalars['Int'];
};

export type UpdateServiceContractInput = {
  readonly id: Scalars['ID'];
  readonly owner?: Maybe<Scalars['String']>;
  readonly propertyId?: Maybe<Scalars['ID']>;
  readonly start?: Maybe<Scalars['AWSDate']>;
  readonly end?: Maybe<Scalars['AWSDate']>;
  readonly type?: Maybe<ServiceType>;
  readonly scope?: Maybe<ScopeInput>;
  readonly measurementsId?: Maybe<Scalars['ID']>;
  readonly costs?: Maybe<ReadonlyArray<CostLineItemInput>>;
  readonly notes?: Maybe<ReadonlyArray<NotePartInput>>;
};

export type FilePropsFragment = (
  { readonly __typename?: 'File' }
  & Pick<File, 'path' | 'identityId'>
);

export type BidPaymentRequirementsFragment = (
  { readonly __typename?: 'Bid' }
  & Pick<Bid, 'id'>
  & { readonly rfp: (
    { readonly __typename?: 'RFP' }
    & { readonly property: Maybe<(
      { readonly __typename?: 'Property' }
      & Pick<Property, 'name' | 'address' | 'city' | 'state' | 'zipcode'>
    )> }
  ) }
);

export type CreateBidMutationVariables = Exact<{
  input: CreateBidInput;
}>;


export type CreateBidMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createBid: Maybe<(
    { readonly __typename?: 'Bid' }
    & Pick<Bid, 'id'>
    & BidPaymentRequirementsFragment
  )> }
);

export type CreateBidRequestMutationVariables = Exact<{
  input: CreateBidRequestInput;
}>;


export type CreateBidRequestMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createBidRequest: Maybe<(
    { readonly __typename?: 'BidRequest' }
    & Pick<BidRequest, 'id' | 'version' | 'requestedEmail'>
    & { readonly rfp: (
      { readonly __typename?: 'RFP' }
      & Pick<Rfp, 'id'>
      & { readonly bidRequests: Maybe<(
        { readonly __typename?: 'ModelBidRequestConnection' }
        & { readonly items: Maybe<ReadonlyArray<Maybe<(
          { readonly __typename?: 'BidRequest' }
          & Pick<BidRequest, 'requestedEmail'>
        )>>> }
      )> }
    ) }
  )> }
);

export type CreatePropertyMutationVariables = Exact<{
  input: CreatePropertyInput;
}>;


export type CreatePropertyMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createProperty: Maybe<(
    { readonly __typename?: 'Property' }
    & BasicPropertyFragment
  )> }
);

export type CreateMeasurementsMutationVariables = Exact<{
  input: CreateMeasurementsInput;
}>;


export type CreateMeasurementsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createMeasurements: Maybe<(
    { readonly __typename?: 'Measurements' }
    & FullMeasurementsFragment
  )> }
);

export type CreateExpensesMutationVariables = Exact<{
  input: CreateExpensesInput;
}>;


export type CreateExpensesMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createExpenses: Maybe<(
    { readonly __typename?: 'Expenses' }
    & FullExpensesFragment
  )> }
);

export type CreateServiceContractMutationVariables = Exact<{
  input: CreateServiceContractInput;
}>;


export type CreateServiceContractMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createServiceContract: Maybe<(
    { readonly __typename?: 'ServiceContract' }
    & FullServiceContractFragment
  )> }
);

export type CreateRfpMutationVariables = Exact<{
  input: CreateRfpInput;
}>;


export type CreateRfpMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createRFP: Maybe<(
    { readonly __typename?: 'RFP' }
    & Pick<Rfp, 'id'>
  )> }
);

export type FlatMeasurementFragment = (
  { readonly __typename?: 'Measurement' }
  & Pick<Measurement, 'label' | 'unit' | 'value'>
);

export type FullMeasurementFragment = (
  { readonly __typename?: 'Measurement' }
  & { readonly breakdown: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Measurement' }
    & { readonly breakdown: Maybe<ReadonlyArray<(
      { readonly __typename?: 'Measurement' }
      & { readonly breakdown: Maybe<ReadonlyArray<(
        { readonly __typename?: 'Measurement' }
        & FlatMeasurementFragment
      )>> }
      & FlatMeasurementFragment
    )>> }
    & FlatMeasurementFragment
  )>> }
  & FlatMeasurementFragment
);

export type FullScheduleFragment = (
  { readonly __typename?: 'ServiceSchedule' }
  & Pick<ServiceSchedule, 'label' | 'chosenFrom' | 'disableChoice'>
);

export type FullServiceFragment = (
  { readonly __typename?: 'Service' }
  & Pick<Service, 'label'>
  & { readonly facets: ReadonlyArray<(
    { readonly __typename?: 'ServiceFacet' }
    & Pick<ServiceFacet, 'label'>
    & { readonly schedule: (
      { readonly __typename?: 'ServiceSchedule' }
      & FullScheduleFragment
    ) }
  )>, readonly schedule: (
    { readonly __typename?: 'ServiceSchedule' }
    & FullScheduleFragment
  ) }
);

export type FullScopeFragment = (
  { readonly __typename?: 'Scope' }
  & { readonly services: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Service' }
    & FullServiceFragment
  )>> }
);

export type FullNotePartFragment = (
  { readonly __typename?: 'NotePart' }
  & Pick<NotePart, 'id' | 'type' | 'text'>
  & { readonly photo: Maybe<(
    { readonly __typename?: 'File' }
    & FilePropsFragment
  )> }
);

export type GetBidQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetBidQuery = (
  { readonly __typename?: 'Query' }
  & { readonly bid: Maybe<(
    { readonly __typename?: 'Bid' }
    & Pick<Bid, 'id' | 'startDate' | 'owner' | 'stripeCheckoutSession'>
    & { readonly items: ReadonlyArray<(
      { readonly __typename?: 'BidLineItem' }
      & Pick<BidLineItem, 'name' | 'price'>
    )>, readonly document: Maybe<(
      { readonly __typename?: 'File' }
      & FilePropsFragment
    )>, readonly rfp: (
      { readonly __typename?: 'RFP' }
      & Pick<Rfp, 'due' | 'state' | 'subType' | 'title' | 'acceptedBidId'>
      & { readonly notes: Maybe<ReadonlyArray<(
        { readonly __typename?: 'NotePart' }
        & FullNotePartFragment
      )>>, readonly scope: Maybe<(
        { readonly __typename?: 'Scope' }
        & FullScopeFragment
      )>, readonly property: Maybe<(
        { readonly __typename?: 'Property' }
        & BasicPropertyFragment
      )> }
      & BasicRfpFragment
      & RfpMeasurementDataFragment
    ), readonly bidder: Maybe<(
      { readonly __typename?: 'Profile' }
      & Pick<Profile, 'name' | 'companyName'>
      & { readonly companyLogo: Maybe<(
        { readonly __typename?: 'File' }
        & FilePropsFragment
      )> }
    )> }
    & BidPaymentRequirementsFragment
  )> }
);

export type BasicPropertyFragment = (
  { readonly __typename?: 'Property' }
  & Pick<Property, 'id' | 'name' | 'address' | 'state' | 'zipcode' | 'city' | 'class' | 'type'>
  & { readonly photo: Maybe<(
    { readonly __typename?: 'File' }
    & FilePropsFragment
  )> }
);

export type PropertyManagerHomeComparableFragment = (
  { readonly __typename?: 'ComparableProperty' }
  & Pick<ComparableProperty, 'id'>
  & { readonly expenses: Maybe<(
    { readonly __typename?: 'ModelExpensesConnection' }
    & Pick<ModelExpensesConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Expenses' }
      & FullExpensesFragment
    )>>> }
  )>, readonly measurements: Maybe<(
    { readonly __typename?: 'ModelMeasurementsConnection' }
    & Pick<ModelMeasurementsConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Measurements' }
      & FullMeasurementsFragment
    )>>> }
  )> }
);

export type PropertyManagerHomePropertyFragment = (
  { readonly __typename?: 'Property' }
  & { readonly comparableProperties: Maybe<(
    { readonly __typename?: 'ModelComparablePropertyConnection' }
    & Pick<ModelComparablePropertyConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ComparableProperty' }
      & PropertyManagerHomeComparableFragment
    )>>> }
  )>, readonly expenses: Maybe<(
    { readonly __typename?: 'ModelExpensesConnection' }
    & Pick<ModelExpensesConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Expenses' }
      & FullExpensesFragment
    )>>> }
  )>, readonly measurements: Maybe<(
    { readonly __typename?: 'ModelMeasurementsConnection' }
    & Pick<ModelMeasurementsConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Measurements' }
      & FullMeasurementsFragment
    )>>> }
  )>, readonly rfps: Maybe<(
    { readonly __typename?: 'ModelRFPConnection' }
    & Pick<ModelRfpConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'RFP' }
      & Pick<Rfp, 'id'>
    )>>> }
  )> }
  & BasicPropertyFragment
);

export type PropertyManagerHomePropertiesFragment = (
  { readonly __typename?: 'ModelPropertyConnection' }
  & { readonly items: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'Property' }
    & PropertyManagerHomePropertyFragment
  )>>> }
);

export type PropertyManagerHomeScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyManagerHomeScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly properties: Maybe<(
    { readonly __typename?: 'ModelPropertyConnection' }
    & PropertyManagerHomePropertiesFragment
  )> }
);

export type BasicRfpFragment = (
  { readonly __typename?: 'RFP' }
  & Pick<Rfp, 'id' | 'version' | 'type'>
);

export type PropertyScreenRfpFragment = (
  { readonly __typename?: 'RFP' }
  & Pick<Rfp, 'propertyId' | 'acceptedBidId' | 'state' | 'due'>
  & { readonly bids: Maybe<(
    { readonly __typename?: 'ModelBidConnection' }
    & Pick<ModelBidConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Bid' }
      & Pick<Bid, 'id'>
    )>>> }
  )> }
  & BasicRfpFragment
);

export type PropertyScreenRfPsFragment = (
  { readonly __typename?: 'ModelRFPConnection' }
  & Pick<ModelRfpConnection, 'nextToken'>
  & { readonly items: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'RFP' }
    & PropertyScreenRfpFragment
  )>>> }
);

export type PropertyScreenPropertyFragment = (
  { readonly __typename?: 'Property' }
  & { readonly rfps: Maybe<(
    { readonly __typename?: 'ModelRFPConnection' }
    & PropertyScreenRfPsFragment
  )>, readonly measurements: Maybe<(
    { readonly __typename?: 'ModelMeasurementsConnection' }
    & Pick<ModelMeasurementsConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Measurements' }
      & FullMeasurementsFragment
    )>>> }
  )>, readonly expenses: Maybe<(
    { readonly __typename?: 'ModelExpensesConnection' }
    & Pick<ModelExpensesConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Expenses' }
      & FullExpensesFragment
    )>>> }
  )>, readonly comparableProperties: Maybe<(
    { readonly __typename?: 'ModelComparablePropertyConnection' }
    & Pick<ModelComparablePropertyConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ComparableProperty' }
      & PropertyManagerHomeComparableFragment
    )>>> }
  )> }
  & BasicPropertyFragment
);

export type PropertyScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly property: Maybe<(
    { readonly __typename?: 'Property' }
    & PropertyScreenPropertyFragment
  )> }
);

export type NewRfpPropertyFragment = (
  { readonly __typename?: 'Property' }
  & BasicPropertyFragment
);

export type NewRfpScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewRfpScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly property: Maybe<(
    { readonly __typename?: 'Property' }
    & NewRfpPropertyFragment
  )> }
);

export type RfpMeasurementDataFragment = (
  { readonly __typename?: 'RFP' }
  & { readonly measurementData: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Measurement' }
    & FullMeasurementFragment
  )>>, readonly measurementPhoto: Maybe<(
    { readonly __typename?: 'File' }
    & FilePropsFragment
  )> }
);

export type NewBidRfpFragment = (
  { readonly __typename?: 'RFP' }
  & Pick<Rfp, 'due' | 'state' | 'subType' | 'title'>
  & { readonly notes: Maybe<ReadonlyArray<(
    { readonly __typename?: 'NotePart' }
    & FullNotePartFragment
  )>>, readonly scope: Maybe<(
    { readonly __typename?: 'Scope' }
    & FullScopeFragment
  )>, readonly property: Maybe<(
    { readonly __typename?: 'Property' }
    & BasicPropertyFragment
  )> }
  & BasicRfpFragment
  & RfpMeasurementDataFragment
);

export type NewBidScreenRfpFragment = (
  { readonly __typename?: 'RFP' }
  & { readonly bids: Maybe<(
    { readonly __typename?: 'ModelBidConnection' }
    & Pick<ModelBidConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Bid' }
      & Pick<Bid, 'id' | 'owner'>
    )>>> }
  )> }
  & NewBidRfpFragment
);

export type NewBidScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type NewBidScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly bidRequest: Maybe<(
    { readonly __typename?: 'BidRequest' }
    & { readonly rfp: (
      { readonly __typename?: 'RFP' }
      & NewBidScreenRfpFragment
    ) }
  )> }
);

export type BasicBidFragment = (
  { readonly __typename?: 'Bid' }
  & Pick<Bid, 'id' | 'rfpId'>
  & { readonly items: ReadonlyArray<(
    { readonly __typename?: 'BidLineItem' }
    & Pick<BidLineItem, 'name' | 'price'>
  )> }
);

export type SubcontractorHomeScreenRfpFragment = (
  { readonly __typename?: 'RFP' }
  & Pick<Rfp, 'state' | 'acceptedBidId' | 'due' | 'propertyId'>
  & { readonly bids: Maybe<(
    { readonly __typename?: 'ModelBidConnection' }
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Bid' }
      & Pick<Bid, 'id'>
    )>>> }
  )>, readonly property: Maybe<(
    { readonly __typename?: 'Property' }
    & BasicPropertyFragment
  )> }
  & BasicRfpFragment
);

export type SubcontractorHomeScreenBidRequestFragment = (
  { readonly __typename?: 'BidRequest' }
  & Pick<BidRequest, 'id'>
  & { readonly rfp: (
    { readonly __typename?: 'RFP' }
    & SubcontractorHomeScreenRfpFragment
  ) }
);

export type SubcontractorHomeScreenBidRequestsFragment = (
  { readonly __typename?: 'ModelBidRequestConnection' }
  & Pick<ModelBidRequestConnection, 'nextToken'>
  & { readonly items: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'BidRequest' }
    & SubcontractorHomeScreenBidRequestFragment
  )>>> }
);

export type RfpScreenBidFragment = (
  { readonly __typename?: 'Bid' }
  & Pick<Bid, 'id' | 'startDate'>
  & { readonly items: ReadonlyArray<(
    { readonly __typename?: 'BidLineItem' }
    & Pick<BidLineItem, 'price' | 'name'>
  )>, readonly bidder: Maybe<(
    { readonly __typename?: 'Profile' }
    & Pick<Profile, 'name' | 'companyName'>
    & { readonly companyLogo: Maybe<(
      { readonly __typename?: 'File' }
      & FilePropsFragment
    )> }
  )>, readonly document: Maybe<(
    { readonly __typename?: 'File' }
    & FilePropsFragment
  )> }
);

export type RfpScreenRfpFragment = (
  { readonly __typename?: 'RFP' }
  & Pick<Rfp, 'title' | 'subType' | 'state' | 'due' | 'acceptedBidId'>
  & { readonly bidRequests: Maybe<(
    { readonly __typename?: 'ModelBidRequestConnection' }
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'BidRequest' }
      & Pick<BidRequest, 'requestedEmail'>
    )>>> }
  )>, readonly property: Maybe<(
    { readonly __typename?: 'Property' }
    & BasicPropertyFragment
  )>, readonly notes: Maybe<ReadonlyArray<(
    { readonly __typename?: 'NotePart' }
    & FullNotePartFragment
  )>>, readonly scope: Maybe<(
    { readonly __typename?: 'Scope' }
    & FullScopeFragment
  )>, readonly bids: Maybe<(
    { readonly __typename?: 'ModelBidConnection' }
    & Pick<ModelBidConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'Bid' }
      & RfpScreenBidFragment
    )>>> }
  )> }
  & BasicRfpFragment
  & RfpMeasurementDataFragment
);

export type RfpScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RfpScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly rfp: Maybe<(
    { readonly __typename?: 'RFP' }
    & RfpScreenRfpFragment
  )> }
);

export type SubcontractorHomeScreenQueryVariables = Exact<{
  owner: Scalars['ID'];
  ownerEmail: Scalars['String'];
  nextToken: Maybe<Scalars['String']>;
}>;


export type SubcontractorHomeScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly bidRequestsByEmail: Maybe<(
    { readonly __typename?: 'ModelBidRequestConnection' }
    & SubcontractorHomeScreenBidRequestsFragment
  )> }
);

export type MetrologistHomeScreenRfpFragment = (
  { readonly __typename?: 'RFP' }
  & Pick<Rfp, 'propertyId'>
  & { readonly property: Maybe<(
    { readonly __typename?: 'Property' }
    & BasicPropertyFragment
  )> }
  & BasicRfpFragment
);

export type MetrologistHomeScreenRfPsFragment = (
  { readonly __typename?: 'ModelRFPConnection' }
  & { readonly items: Maybe<ReadonlyArray<Maybe<(
    { readonly __typename?: 'RFP' }
    & MetrologistHomeScreenRfpFragment
  )>>> }
);

export type MetrologistHomeScreenQueryVariables = Exact<{ [key: string]: never; }>;


export type MetrologistHomeScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly rfpsByState: Maybe<(
    { readonly __typename?: 'ModelRFPConnection' }
    & MetrologistHomeScreenRfPsFragment
  )> }
);

export type RfpMeasurementScreenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RfpMeasurementScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly rfp: Maybe<(
    { readonly __typename?: 'RFP' }
    & { readonly property: Maybe<(
      { readonly __typename?: 'Property' }
      & BasicPropertyFragment
    )>, readonly measurementData: Maybe<ReadonlyArray<(
      { readonly __typename?: 'Measurement' }
      & FullMeasurementFragment
    )>> }
    & BasicRfpFragment
  )> }
);

export type SubmitRfpMeasurementsMutationVariables = Exact<{
  id: Scalars['ID'];
  expectedVerion: Scalars['Int'];
  measurementData: ReadonlyArray<MeasurementInput>;
  measurementPhoto: Maybe<FileInput>;
  state: Maybe<RfpState>;
}>;


export type SubmitRfpMeasurementsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateRFP: Maybe<(
    { readonly __typename?: 'RFP' }
    & Pick<Rfp, 'id' | 'version'>
  )> }
);

export type FullProfileFragment = (
  { readonly __typename?: 'Profile' }
  & Pick<Profile, 'username' | 'version' | 'name' | 'persona' | 'companyName' | 'agreedToTermsOfUse' | 'termsOfUseVersion'>
  & { readonly photo: Maybe<(
    { readonly __typename?: 'File' }
    & FilePropsFragment
  )>, readonly companyLogo: Maybe<(
    { readonly __typename?: 'File' }
    & FilePropsFragment
  )> }
);

export type CreateProfileMutationVariables = Exact<{
  input: CreateProfileInput;
}>;


export type CreateProfileMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createProfile: Maybe<(
    { readonly __typename?: 'Profile' }
    & FullProfileFragment
  )> }
);

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateProfileInput;
}>;


export type UpdateProfileMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateProfile: Maybe<(
    { readonly __typename?: 'Profile' }
    & FullProfileFragment
  )> }
);

export type ProfileScreenQueryVariables = Exact<{
  username: Scalars['ID'];
}>;


export type ProfileScreenQuery = (
  { readonly __typename?: 'Query' }
  & { readonly profile: Maybe<(
    { readonly __typename?: 'Profile' }
    & FullProfileFragment
  )> }
);

export type AcceptBidMutationVariables = Exact<{
  rfpId: Scalars['ID'];
  rfpVersion: Scalars['Int'];
  bidId: Scalars['ID'];
}>;


export type AcceptBidMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateRFP: Maybe<(
    { readonly __typename?: 'RFP' }
    & Pick<Rfp, 'id' | 'version' | 'acceptedBidId'>
  )> }
);

export type ApproveMeasurementsMutationVariables = Exact<{
  rfpId: Scalars['ID'];
  rfpVersion: Scalars['Int'];
}>;


export type ApproveMeasurementsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateRFP: Maybe<(
    { readonly __typename?: 'RFP' }
    & Pick<Rfp, 'id' | 'version' | 'state'>
  )> }
);

export type StartBidPaymentMutationVariables = Exact<{
  bidId: Scalars['ID'];
  description: Maybe<Scalars['String']>;
}>;


export type StartBidPaymentMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly startStripeCheckoutSessionForBid: (
    { readonly __typename?: 'StripeCheckout' }
    & Pick<StripeCheckout, 'sessionId'>
  ) }
);

export type CreateOrLinkUserMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateOrLinkUserMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly createOrLinkUser: (
    { readonly __typename?: 'CreateOrLinkUserResponse' }
    & Pick<CreateOrLinkUserResponse, 'username' | 'token'>
  ) }
);

export type FullMeasurementsFragment = (
  { readonly __typename?: 'Measurements' }
  & Pick<Measurements, 'id' | 'version' | 'propertyId'>
  & { readonly values: Maybe<ReadonlyArray<(
    { readonly __typename?: 'Measurement' }
    & FullMeasurementFragment
  )>> }
);

export type FullExpensesFragment = (
  { readonly __typename?: 'Expenses' }
  & Pick<Expenses, 'id' | 'version' | 'propertyId' | 'date'>
  & { readonly analysis: Maybe<(
    { readonly __typename?: 'ExpenseAnalysis' }
    & Pick<ExpenseAnalysis, 'costPercentage'>
  )>, readonly lineItems: ReadonlyArray<(
    { readonly __typename?: 'ExpenseLineItem' }
    & Pick<ExpenseLineItem, 'name' | 'amount'>
    & { readonly analysis: Maybe<(
      { readonly __typename?: 'ExpenseAnalysis' }
      & Pick<ExpenseAnalysis, 'costPercentage'>
    )>, readonly breakdown: ReadonlyArray<(
      { readonly __typename?: 'ExpenseLineItemDetail' }
      & Pick<ExpenseLineItemDetail, 'name' | 'amount'>
    )> }
  )> }
);

export type FullServiceContractFragment = (
  { readonly __typename?: 'ServiceContract' }
  & Pick<ServiceContract, 'id' | 'type' | 'measurementsId'>
  & { readonly costs: ReadonlyArray<(
    { readonly __typename?: 'CostLineItem' }
    & Pick<CostLineItem, 'name' | 'price' | 'schedule'>
  )>, readonly measurements: Maybe<(
    { readonly __typename?: 'Measurements' }
    & FullMeasurementsFragment
  )> }
);

export type ServiceContractsQueryVariables = Exact<{
  propertyId: Scalars['ID'];
  serviceType: ServiceType;
}>;


export type ServiceContractsQuery = (
  { readonly __typename?: 'Query' }
  & { readonly serviceContractsForProperty: Maybe<(
    { readonly __typename?: 'ModelServiceContractConnection' }
    & Pick<ModelServiceContractConnection, 'nextToken'>
    & { readonly items: Maybe<ReadonlyArray<Maybe<(
      { readonly __typename?: 'ServiceContract' }
      & FullServiceContractFragment
    )>>> }
  )> }
);

export type UpdateMeasurementsMutationVariables = Exact<{
  input: UpdateMeasurementsInput;
}>;


export type UpdateMeasurementsMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateMeasurements: Maybe<(
    { readonly __typename?: 'Measurements' }
    & FullMeasurementsFragment
  )> }
);

export type UpdateExpensesMutationVariables = Exact<{
  input: UpdateExpensesInput;
}>;


export type UpdateExpensesMutation = (
  { readonly __typename?: 'Mutation' }
  & { readonly updateExpenses: Maybe<(
    { readonly __typename?: 'Expenses' }
    & FullExpensesFragment
  )> }
);

export const BidPaymentRequirementsFragmentDoc = gql`
    fragment BidPaymentRequirements on Bid {
  id
  rfp {
    property {
      name
      address
      city
      state
      zipcode
    }
  }
}
    `;
export const FilePropsFragmentDoc = gql`
    fragment FileProps on File {
  path
  identityId
}
    `;
export const BasicPropertyFragmentDoc = gql`
    fragment BasicProperty on Property {
  id
  name
  address
  state
  zipcode
  city
  photo {
    ...FileProps
  }
  class
  type
}
    ${FilePropsFragmentDoc}`;
export const FullExpensesFragmentDoc = gql`
    fragment FullExpenses on Expenses {
  id
  version
  propertyId
  date
  analysis {
    costPercentage
  }
  lineItems {
    analysis {
      costPercentage
    }
    name
    amount
    breakdown {
      name
      amount
    }
  }
}
    `;
export const FlatMeasurementFragmentDoc = gql`
    fragment FlatMeasurement on Measurement {
  label
  unit
  value
}
    `;
export const FullMeasurementFragmentDoc = gql`
    fragment FullMeasurement on Measurement {
  ...FlatMeasurement
  breakdown {
    ...FlatMeasurement
    breakdown {
      ...FlatMeasurement
      breakdown {
        ...FlatMeasurement
      }
    }
  }
}
    ${FlatMeasurementFragmentDoc}`;
export const FullMeasurementsFragmentDoc = gql`
    fragment FullMeasurements on Measurements {
  id
  version
  propertyId
  values {
    ...FullMeasurement
  }
}
    ${FullMeasurementFragmentDoc}`;
export const PropertyManagerHomeComparableFragmentDoc = gql`
    fragment PropertyManagerHomeComparable on ComparableProperty {
  id
  expenses {
    items {
      ...FullExpenses
    }
    nextToken
  }
  measurements {
    items {
      ...FullMeasurements
    }
    nextToken
  }
}
    ${FullExpensesFragmentDoc}
${FullMeasurementsFragmentDoc}`;
export const PropertyManagerHomePropertyFragmentDoc = gql`
    fragment PropertyManagerHomeProperty on Property {
  ...BasicProperty
  comparableProperties {
    items {
      ...PropertyManagerHomeComparable
    }
    nextToken
  }
  expenses {
    items {
      ...FullExpenses
    }
    nextToken
  }
  measurements {
    items {
      ...FullMeasurements
    }
    nextToken
  }
  rfps {
    items {
      id
    }
    nextToken
  }
}
    ${BasicPropertyFragmentDoc}
${PropertyManagerHomeComparableFragmentDoc}
${FullExpensesFragmentDoc}
${FullMeasurementsFragmentDoc}`;
export const PropertyManagerHomePropertiesFragmentDoc = gql`
    fragment PropertyManagerHomeProperties on ModelPropertyConnection {
  items {
    ...PropertyManagerHomeProperty
  }
}
    ${PropertyManagerHomePropertyFragmentDoc}`;
export const BasicRfpFragmentDoc = gql`
    fragment BasicRFP on RFP {
  id
  version
  type
}
    `;
export const PropertyScreenRfpFragmentDoc = gql`
    fragment PropertyScreenRFP on RFP {
  ...BasicRFP
  propertyId
  acceptedBidId
  state
  due
  bids {
    items {
      id
    }
    nextToken
  }
}
    ${BasicRfpFragmentDoc}`;
export const PropertyScreenRfPsFragmentDoc = gql`
    fragment PropertyScreenRFPs on ModelRFPConnection {
  items {
    ...PropertyScreenRFP
  }
  nextToken
}
    ${PropertyScreenRfpFragmentDoc}`;
export const PropertyScreenPropertyFragmentDoc = gql`
    fragment PropertyScreenProperty on Property {
  ...BasicProperty
  rfps {
    ...PropertyScreenRFPs
  }
  measurements {
    items {
      ...FullMeasurements
    }
    nextToken
  }
  expenses {
    items {
      ...FullExpenses
    }
    nextToken
  }
  comparableProperties {
    items {
      ...PropertyManagerHomeComparable
    }
    nextToken
  }
}
    ${BasicPropertyFragmentDoc}
${PropertyScreenRfPsFragmentDoc}
${FullMeasurementsFragmentDoc}
${FullExpensesFragmentDoc}
${PropertyManagerHomeComparableFragmentDoc}`;
export const NewRfpPropertyFragmentDoc = gql`
    fragment NewRFPProperty on Property {
  ...BasicProperty
}
    ${BasicPropertyFragmentDoc}`;
export const RfpMeasurementDataFragmentDoc = gql`
    fragment RFPMeasurementData on RFP {
  measurementData {
    ...FullMeasurement
  }
  measurementPhoto {
    ...FileProps
  }
}
    ${FullMeasurementFragmentDoc}
${FilePropsFragmentDoc}`;
export const FullNotePartFragmentDoc = gql`
    fragment FullNotePart on NotePart {
  id
  type
  text
  photo {
    ...FileProps
  }
}
    ${FilePropsFragmentDoc}`;
export const FullScheduleFragmentDoc = gql`
    fragment FullSchedule on ServiceSchedule {
  label
  chosenFrom
  disableChoice
}
    `;
export const FullServiceFragmentDoc = gql`
    fragment FullService on Service {
  label
  facets {
    label
    schedule {
      ...FullSchedule
    }
  }
  schedule {
    ...FullSchedule
  }
}
    ${FullScheduleFragmentDoc}`;
export const FullScopeFragmentDoc = gql`
    fragment FullScope on Scope {
  services {
    ...FullService
  }
}
    ${FullServiceFragmentDoc}`;
export const NewBidRfpFragmentDoc = gql`
    fragment NewBidRFP on RFP {
  ...BasicRFP
  ...RFPMeasurementData
  due
  state
  subType
  title
  notes {
    ...FullNotePart
  }
  scope {
    ...FullScope
  }
  property {
    ...BasicProperty
  }
}
    ${BasicRfpFragmentDoc}
${RfpMeasurementDataFragmentDoc}
${FullNotePartFragmentDoc}
${FullScopeFragmentDoc}
${BasicPropertyFragmentDoc}`;
export const NewBidScreenRfpFragmentDoc = gql`
    fragment NewBidScreenRFP on RFP {
  ...NewBidRFP
  bids {
    items {
      id
      owner
    }
    nextToken
  }
}
    ${NewBidRfpFragmentDoc}`;
export const BasicBidFragmentDoc = gql`
    fragment BasicBid on Bid {
  id
  rfpId
  items {
    name
    price
  }
}
    `;
export const SubcontractorHomeScreenRfpFragmentDoc = gql`
    fragment SubcontractorHomeScreenRFP on RFP {
  ...BasicRFP
  bids(filter: {owner: {eq: $owner}}) {
    items {
      id
    }
  }
  state
  acceptedBidId
  due
  propertyId
  property {
    ...BasicProperty
  }
}
    ${BasicRfpFragmentDoc}
${BasicPropertyFragmentDoc}`;
export const SubcontractorHomeScreenBidRequestFragmentDoc = gql`
    fragment SubcontractorHomeScreenBidRequest on BidRequest {
  id
  rfp {
    ...SubcontractorHomeScreenRFP
  }
}
    ${SubcontractorHomeScreenRfpFragmentDoc}`;
export const SubcontractorHomeScreenBidRequestsFragmentDoc = gql`
    fragment SubcontractorHomeScreenBidRequests on ModelBidRequestConnection {
  items {
    ...SubcontractorHomeScreenBidRequest
  }
  nextToken
}
    ${SubcontractorHomeScreenBidRequestFragmentDoc}`;
export const RfpScreenBidFragmentDoc = gql`
    fragment RFPScreenBid on Bid {
  id
  items {
    price
    name
  }
  startDate
  bidder {
    name
    companyName
    companyLogo {
      ...FileProps
    }
  }
  document {
    ...FileProps
  }
}
    ${FilePropsFragmentDoc}`;
export const RfpScreenRfpFragmentDoc = gql`
    fragment RFPScreenRFP on RFP {
  ...BasicRFP
  ...RFPMeasurementData
  bidRequests {
    items {
      requestedEmail
    }
  }
  property {
    ...BasicProperty
  }
  notes {
    ...FullNotePart
  }
  title
  subType
  state
  due
  scope {
    ...FullScope
  }
  acceptedBidId
  bids {
    items {
      ...RFPScreenBid
    }
    nextToken
  }
}
    ${BasicRfpFragmentDoc}
${RfpMeasurementDataFragmentDoc}
${BasicPropertyFragmentDoc}
${FullNotePartFragmentDoc}
${FullScopeFragmentDoc}
${RfpScreenBidFragmentDoc}`;
export const MetrologistHomeScreenRfpFragmentDoc = gql`
    fragment MetrologistHomeScreenRFP on RFP {
  ...BasicRFP
  propertyId
  property {
    ...BasicProperty
  }
}
    ${BasicRfpFragmentDoc}
${BasicPropertyFragmentDoc}`;
export const MetrologistHomeScreenRfPsFragmentDoc = gql`
    fragment MetrologistHomeScreenRFPs on ModelRFPConnection {
  items {
    ...MetrologistHomeScreenRFP
  }
}
    ${MetrologistHomeScreenRfpFragmentDoc}`;
export const FullProfileFragmentDoc = gql`
    fragment FullProfile on Profile {
  username
  version
  name
  persona
  photo {
    ...FileProps
  }
  companyName
  companyLogo {
    ...FileProps
  }
  agreedToTermsOfUse
  termsOfUseVersion
}
    ${FilePropsFragmentDoc}`;
export const FullServiceContractFragmentDoc = gql`
    fragment FullServiceContract on ServiceContract {
  id
  type
  costs {
    name
    price
    schedule
  }
  measurementsId
  measurements {
    ...FullMeasurements
  }
}
    ${FullMeasurementsFragmentDoc}`;
export const CreateBidDocument = gql`
    mutation CreateBid($input: CreateBidInput!) {
  createBid(input: $input) {
    ...BidPaymentRequirements
    id
  }
}
    ${BidPaymentRequirementsFragmentDoc}`;
export type CreateBidMutationFn = ApolloReactCommon.MutationFunction<CreateBidMutation, CreateBidMutationVariables>;

/**
 * __useCreateBidMutation__
 *
 * To run a mutation, you first call `useCreateBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBidMutation, { data, loading, error }] = useCreateBidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBidMutation, CreateBidMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBidMutation, CreateBidMutationVariables>(CreateBidDocument, baseOptions);
      }
export type CreateBidMutationHookResult = ReturnType<typeof useCreateBidMutation>;
export type CreateBidMutationResult = ApolloReactCommon.MutationResult<CreateBidMutation>;
export type CreateBidMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBidMutation, CreateBidMutationVariables>;
export const CreateBidRequestDocument = gql`
    mutation CreateBidRequest($input: CreateBidRequestInput!) {
  createBidRequest(input: $input) {
    id
    version
    requestedEmail
    rfp {
      id
      bidRequests {
        items {
          requestedEmail
        }
      }
    }
  }
}
    `;
export type CreateBidRequestMutationFn = ApolloReactCommon.MutationFunction<CreateBidRequestMutation, CreateBidRequestMutationVariables>;

/**
 * __useCreateBidRequestMutation__
 *
 * To run a mutation, you first call `useCreateBidRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBidRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBidRequestMutation, { data, loading, error }] = useCreateBidRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBidRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBidRequestMutation, CreateBidRequestMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateBidRequestMutation, CreateBidRequestMutationVariables>(CreateBidRequestDocument, baseOptions);
      }
export type CreateBidRequestMutationHookResult = ReturnType<typeof useCreateBidRequestMutation>;
export type CreateBidRequestMutationResult = ApolloReactCommon.MutationResult<CreateBidRequestMutation>;
export type CreateBidRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateBidRequestMutation, CreateBidRequestMutationVariables>;
export const CreatePropertyDocument = gql`
    mutation CreateProperty($input: CreatePropertyInput!) {
  createProperty(input: $input) {
    ...BasicProperty
  }
}
    ${BasicPropertyFragmentDoc}`;
export type CreatePropertyMutationFn = ApolloReactCommon.MutationFunction<CreatePropertyMutation, CreatePropertyMutationVariables>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePropertyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>) {
        return ApolloReactHooks.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(CreatePropertyDocument, baseOptions);
      }
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = ApolloReactCommon.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = ApolloReactCommon.BaseMutationOptions<CreatePropertyMutation, CreatePropertyMutationVariables>;
export const CreateMeasurementsDocument = gql`
    mutation CreateMeasurements($input: CreateMeasurementsInput!) {
  createMeasurements(input: $input) {
    ...FullMeasurements
  }
}
    ${FullMeasurementsFragmentDoc}`;
export type CreateMeasurementsMutationFn = ApolloReactCommon.MutationFunction<CreateMeasurementsMutation, CreateMeasurementsMutationVariables>;

/**
 * __useCreateMeasurementsMutation__
 *
 * To run a mutation, you first call `useCreateMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMeasurementsMutation, { data, loading, error }] = useCreateMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMeasurementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMeasurementsMutation, CreateMeasurementsMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateMeasurementsMutation, CreateMeasurementsMutationVariables>(CreateMeasurementsDocument, baseOptions);
      }
export type CreateMeasurementsMutationHookResult = ReturnType<typeof useCreateMeasurementsMutation>;
export type CreateMeasurementsMutationResult = ApolloReactCommon.MutationResult<CreateMeasurementsMutation>;
export type CreateMeasurementsMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateMeasurementsMutation, CreateMeasurementsMutationVariables>;
export const CreateExpensesDocument = gql`
    mutation CreateExpenses($input: CreateExpensesInput!) {
  createExpenses(input: $input) {
    ...FullExpenses
  }
}
    ${FullExpensesFragmentDoc}`;
export type CreateExpensesMutationFn = ApolloReactCommon.MutationFunction<CreateExpensesMutation, CreateExpensesMutationVariables>;

/**
 * __useCreateExpensesMutation__
 *
 * To run a mutation, you first call `useCreateExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExpensesMutation, { data, loading, error }] = useCreateExpensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExpensesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateExpensesMutation, CreateExpensesMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateExpensesMutation, CreateExpensesMutationVariables>(CreateExpensesDocument, baseOptions);
      }
export type CreateExpensesMutationHookResult = ReturnType<typeof useCreateExpensesMutation>;
export type CreateExpensesMutationResult = ApolloReactCommon.MutationResult<CreateExpensesMutation>;
export type CreateExpensesMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateExpensesMutation, CreateExpensesMutationVariables>;
export const CreateServiceContractDocument = gql`
    mutation CreateServiceContract($input: CreateServiceContractInput!) {
  createServiceContract(input: $input) {
    ...FullServiceContract
  }
}
    ${FullServiceContractFragmentDoc}`;
export type CreateServiceContractMutationFn = ApolloReactCommon.MutationFunction<CreateServiceContractMutation, CreateServiceContractMutationVariables>;

/**
 * __useCreateServiceContractMutation__
 *
 * To run a mutation, you first call `useCreateServiceContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceContractMutation, { data, loading, error }] = useCreateServiceContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateServiceContractMutation, CreateServiceContractMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateServiceContractMutation, CreateServiceContractMutationVariables>(CreateServiceContractDocument, baseOptions);
      }
export type CreateServiceContractMutationHookResult = ReturnType<typeof useCreateServiceContractMutation>;
export type CreateServiceContractMutationResult = ApolloReactCommon.MutationResult<CreateServiceContractMutation>;
export type CreateServiceContractMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateServiceContractMutation, CreateServiceContractMutationVariables>;
export const CreateRfpDocument = gql`
    mutation CreateRFP($input: CreateRFPInput!) {
  createRFP(input: $input) {
    id
  }
}
    `;
export type CreateRfpMutationFn = ApolloReactCommon.MutationFunction<CreateRfpMutation, CreateRfpMutationVariables>;

/**
 * __useCreateRfpMutation__
 *
 * To run a mutation, you first call `useCreateRfpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRfpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRfpMutation, { data, loading, error }] = useCreateRfpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRfpMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRfpMutation, CreateRfpMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateRfpMutation, CreateRfpMutationVariables>(CreateRfpDocument, baseOptions);
      }
export type CreateRfpMutationHookResult = ReturnType<typeof useCreateRfpMutation>;
export type CreateRfpMutationResult = ApolloReactCommon.MutationResult<CreateRfpMutation>;
export type CreateRfpMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRfpMutation, CreateRfpMutationVariables>;
export const GetBidDocument = gql`
    query GetBid($id: ID!) {
  bid(id: $id) {
    ...BidPaymentRequirements
    id
    items {
      name
      price
    }
    startDate
    document {
      ...FileProps
    }
    rfp {
      ...BasicRFP
      ...RFPMeasurementData
      due
      state
      subType
      title
      acceptedBidId
      notes {
        ...FullNotePart
      }
      scope {
        ...FullScope
      }
      property {
        ...BasicProperty
      }
    }
    owner
    bidder {
      name
      companyName
      companyLogo {
        ...FileProps
      }
    }
    stripeCheckoutSession
  }
}
    ${BidPaymentRequirementsFragmentDoc}
${FilePropsFragmentDoc}
${BasicRfpFragmentDoc}
${RfpMeasurementDataFragmentDoc}
${FullNotePartFragmentDoc}
${FullScopeFragmentDoc}
${BasicPropertyFragmentDoc}`;

/**
 * __useGetBidQuery__
 *
 * To run a query within a React component, call `useGetBidQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBidQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBidQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetBidQuery, GetBidQueryVariables>) {
        return ApolloReactHooks.useQuery<GetBidQuery, GetBidQueryVariables>(GetBidDocument, baseOptions);
      }
export function useGetBidLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetBidQuery, GetBidQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetBidQuery, GetBidQueryVariables>(GetBidDocument, baseOptions);
        }
export type GetBidQueryHookResult = ReturnType<typeof useGetBidQuery>;
export type GetBidLazyQueryHookResult = ReturnType<typeof useGetBidLazyQuery>;
export type GetBidQueryResult = ApolloReactCommon.QueryResult<GetBidQuery, GetBidQueryVariables>;
export const PropertyManagerHomeScreenDocument = gql`
    query PropertyManagerHomeScreen {
  properties {
    ...PropertyManagerHomeProperties
  }
}
    ${PropertyManagerHomePropertiesFragmentDoc}`;

/**
 * __usePropertyManagerHomeScreenQuery__
 *
 * To run a query within a React component, call `usePropertyManagerHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyManagerHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyManagerHomeScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function usePropertyManagerHomeScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PropertyManagerHomeScreenQuery, PropertyManagerHomeScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<PropertyManagerHomeScreenQuery, PropertyManagerHomeScreenQueryVariables>(PropertyManagerHomeScreenDocument, baseOptions);
      }
export function usePropertyManagerHomeScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PropertyManagerHomeScreenQuery, PropertyManagerHomeScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PropertyManagerHomeScreenQuery, PropertyManagerHomeScreenQueryVariables>(PropertyManagerHomeScreenDocument, baseOptions);
        }
export type PropertyManagerHomeScreenQueryHookResult = ReturnType<typeof usePropertyManagerHomeScreenQuery>;
export type PropertyManagerHomeScreenLazyQueryHookResult = ReturnType<typeof usePropertyManagerHomeScreenLazyQuery>;
export type PropertyManagerHomeScreenQueryResult = ApolloReactCommon.QueryResult<PropertyManagerHomeScreenQuery, PropertyManagerHomeScreenQueryVariables>;
export const PropertyScreenDocument = gql`
    query PropertyScreen($id: ID!) {
  property(id: $id) {
    ...PropertyScreenProperty
  }
}
    ${PropertyScreenPropertyFragmentDoc}`;

/**
 * __usePropertyScreenQuery__
 *
 * To run a query within a React component, call `usePropertyScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PropertyScreenQuery, PropertyScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<PropertyScreenQuery, PropertyScreenQueryVariables>(PropertyScreenDocument, baseOptions);
      }
export function usePropertyScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PropertyScreenQuery, PropertyScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PropertyScreenQuery, PropertyScreenQueryVariables>(PropertyScreenDocument, baseOptions);
        }
export type PropertyScreenQueryHookResult = ReturnType<typeof usePropertyScreenQuery>;
export type PropertyScreenLazyQueryHookResult = ReturnType<typeof usePropertyScreenLazyQuery>;
export type PropertyScreenQueryResult = ApolloReactCommon.QueryResult<PropertyScreenQuery, PropertyScreenQueryVariables>;
export const NewRfpScreenDocument = gql`
    query NewRFPScreen($id: ID!) {
  property(id: $id) {
    ...NewRFPProperty
  }
}
    ${NewRfpPropertyFragmentDoc}`;

/**
 * __useNewRfpScreenQuery__
 *
 * To run a query within a React component, call `useNewRfpScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewRfpScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewRfpScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewRfpScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NewRfpScreenQuery, NewRfpScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<NewRfpScreenQuery, NewRfpScreenQueryVariables>(NewRfpScreenDocument, baseOptions);
      }
export function useNewRfpScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewRfpScreenQuery, NewRfpScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NewRfpScreenQuery, NewRfpScreenQueryVariables>(NewRfpScreenDocument, baseOptions);
        }
export type NewRfpScreenQueryHookResult = ReturnType<typeof useNewRfpScreenQuery>;
export type NewRfpScreenLazyQueryHookResult = ReturnType<typeof useNewRfpScreenLazyQuery>;
export type NewRfpScreenQueryResult = ApolloReactCommon.QueryResult<NewRfpScreenQuery, NewRfpScreenQueryVariables>;
export const NewBidScreenDocument = gql`
    query NewBidScreen($id: ID!) {
  bidRequest(id: $id) {
    rfp {
      ...NewBidScreenRFP
    }
  }
}
    ${NewBidScreenRfpFragmentDoc}`;

/**
 * __useNewBidScreenQuery__
 *
 * To run a query within a React component, call `useNewBidScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewBidScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewBidScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNewBidScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NewBidScreenQuery, NewBidScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<NewBidScreenQuery, NewBidScreenQueryVariables>(NewBidScreenDocument, baseOptions);
      }
export function useNewBidScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewBidScreenQuery, NewBidScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<NewBidScreenQuery, NewBidScreenQueryVariables>(NewBidScreenDocument, baseOptions);
        }
export type NewBidScreenQueryHookResult = ReturnType<typeof useNewBidScreenQuery>;
export type NewBidScreenLazyQueryHookResult = ReturnType<typeof useNewBidScreenLazyQuery>;
export type NewBidScreenQueryResult = ApolloReactCommon.QueryResult<NewBidScreenQuery, NewBidScreenQueryVariables>;
export const RfpScreenDocument = gql`
    query RFPScreen($id: ID!) {
  rfp(id: $id) {
    ...RFPScreenRFP
  }
}
    ${RfpScreenRfpFragmentDoc}`;

/**
 * __useRfpScreenQuery__
 *
 * To run a query within a React component, call `useRfpScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRfpScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRfpScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRfpScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RfpScreenQuery, RfpScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<RfpScreenQuery, RfpScreenQueryVariables>(RfpScreenDocument, baseOptions);
      }
export function useRfpScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RfpScreenQuery, RfpScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RfpScreenQuery, RfpScreenQueryVariables>(RfpScreenDocument, baseOptions);
        }
export type RfpScreenQueryHookResult = ReturnType<typeof useRfpScreenQuery>;
export type RfpScreenLazyQueryHookResult = ReturnType<typeof useRfpScreenLazyQuery>;
export type RfpScreenQueryResult = ApolloReactCommon.QueryResult<RfpScreenQuery, RfpScreenQueryVariables>;
export const SubcontractorHomeScreenDocument = gql`
    query SubcontractorHomeScreen($owner: ID!, $ownerEmail: String!, $nextToken: String) {
  bidRequestsByEmail(requestedEmail: $ownerEmail, nextToken: $nextToken) {
    ...SubcontractorHomeScreenBidRequests
  }
}
    ${SubcontractorHomeScreenBidRequestsFragmentDoc}`;

/**
 * __useSubcontractorHomeScreenQuery__
 *
 * To run a query within a React component, call `useSubcontractorHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubcontractorHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubcontractorHomeScreenQuery({
 *   variables: {
 *      owner: // value for 'owner'
 *      ownerEmail: // value for 'ownerEmail'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useSubcontractorHomeScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SubcontractorHomeScreenQuery, SubcontractorHomeScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<SubcontractorHomeScreenQuery, SubcontractorHomeScreenQueryVariables>(SubcontractorHomeScreenDocument, baseOptions);
      }
export function useSubcontractorHomeScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SubcontractorHomeScreenQuery, SubcontractorHomeScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<SubcontractorHomeScreenQuery, SubcontractorHomeScreenQueryVariables>(SubcontractorHomeScreenDocument, baseOptions);
        }
export type SubcontractorHomeScreenQueryHookResult = ReturnType<typeof useSubcontractorHomeScreenQuery>;
export type SubcontractorHomeScreenLazyQueryHookResult = ReturnType<typeof useSubcontractorHomeScreenLazyQuery>;
export type SubcontractorHomeScreenQueryResult = ApolloReactCommon.QueryResult<SubcontractorHomeScreenQuery, SubcontractorHomeScreenQueryVariables>;
export const MetrologistHomeScreenDocument = gql`
    query MetrologistHomeScreen {
  rfpsByState(state: NEEDS_MEASUREMENT) {
    ...MetrologistHomeScreenRFPs
  }
}
    ${MetrologistHomeScreenRfPsFragmentDoc}`;

/**
 * __useMetrologistHomeScreenQuery__
 *
 * To run a query within a React component, call `useMetrologistHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrologistHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrologistHomeScreenQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetrologistHomeScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetrologistHomeScreenQuery, MetrologistHomeScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<MetrologistHomeScreenQuery, MetrologistHomeScreenQueryVariables>(MetrologistHomeScreenDocument, baseOptions);
      }
export function useMetrologistHomeScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetrologistHomeScreenQuery, MetrologistHomeScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MetrologistHomeScreenQuery, MetrologistHomeScreenQueryVariables>(MetrologistHomeScreenDocument, baseOptions);
        }
export type MetrologistHomeScreenQueryHookResult = ReturnType<typeof useMetrologistHomeScreenQuery>;
export type MetrologistHomeScreenLazyQueryHookResult = ReturnType<typeof useMetrologistHomeScreenLazyQuery>;
export type MetrologistHomeScreenQueryResult = ApolloReactCommon.QueryResult<MetrologistHomeScreenQuery, MetrologistHomeScreenQueryVariables>;
export const RfpMeasurementScreenDocument = gql`
    query RFPMeasurementScreen($id: ID!) {
  rfp(id: $id) {
    ...BasicRFP
    property {
      ...BasicProperty
    }
    measurementData {
      ...FullMeasurement
    }
  }
}
    ${BasicRfpFragmentDoc}
${BasicPropertyFragmentDoc}
${FullMeasurementFragmentDoc}`;

/**
 * __useRfpMeasurementScreenQuery__
 *
 * To run a query within a React component, call `useRfpMeasurementScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRfpMeasurementScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRfpMeasurementScreenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRfpMeasurementScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RfpMeasurementScreenQuery, RfpMeasurementScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<RfpMeasurementScreenQuery, RfpMeasurementScreenQueryVariables>(RfpMeasurementScreenDocument, baseOptions);
      }
export function useRfpMeasurementScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RfpMeasurementScreenQuery, RfpMeasurementScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<RfpMeasurementScreenQuery, RfpMeasurementScreenQueryVariables>(RfpMeasurementScreenDocument, baseOptions);
        }
export type RfpMeasurementScreenQueryHookResult = ReturnType<typeof useRfpMeasurementScreenQuery>;
export type RfpMeasurementScreenLazyQueryHookResult = ReturnType<typeof useRfpMeasurementScreenLazyQuery>;
export type RfpMeasurementScreenQueryResult = ApolloReactCommon.QueryResult<RfpMeasurementScreenQuery, RfpMeasurementScreenQueryVariables>;
export const SubmitRfpMeasurementsDocument = gql`
    mutation SubmitRFPMeasurements($id: ID!, $expectedVerion: Int!, $measurementData: [MeasurementInput!]!, $measurementPhoto: FileInput, $state: RfpState) {
  updateRFP(input: {id: $id, measurementData: $measurementData, measurementPhoto: $measurementPhoto, expectedVersion: $expectedVerion, state: $state}) {
    id
    version
  }
}
    `;
export type SubmitRfpMeasurementsMutationFn = ApolloReactCommon.MutationFunction<SubmitRfpMeasurementsMutation, SubmitRfpMeasurementsMutationVariables>;

/**
 * __useSubmitRfpMeasurementsMutation__
 *
 * To run a mutation, you first call `useSubmitRfpMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitRfpMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitRfpMeasurementsMutation, { data, loading, error }] = useSubmitRfpMeasurementsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expectedVerion: // value for 'expectedVerion'
 *      measurementData: // value for 'measurementData'
 *      measurementPhoto: // value for 'measurementPhoto'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSubmitRfpMeasurementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubmitRfpMeasurementsMutation, SubmitRfpMeasurementsMutationVariables>) {
        return ApolloReactHooks.useMutation<SubmitRfpMeasurementsMutation, SubmitRfpMeasurementsMutationVariables>(SubmitRfpMeasurementsDocument, baseOptions);
      }
export type SubmitRfpMeasurementsMutationHookResult = ReturnType<typeof useSubmitRfpMeasurementsMutation>;
export type SubmitRfpMeasurementsMutationResult = ApolloReactCommon.MutationResult<SubmitRfpMeasurementsMutation>;
export type SubmitRfpMeasurementsMutationOptions = ApolloReactCommon.BaseMutationOptions<SubmitRfpMeasurementsMutation, SubmitRfpMeasurementsMutationVariables>;
export const CreateProfileDocument = gql`
    mutation CreateProfile($input: CreateProfileInput!) {
  createProfile(input: $input) {
    ...FullProfile
  }
}
    ${FullProfileFragmentDoc}`;
export type CreateProfileMutationFn = ApolloReactCommon.MutationFunction<CreateProfileMutation, CreateProfileMutationVariables>;

/**
 * __useCreateProfileMutation__
 *
 * To run a mutation, you first call `useCreateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProfileMutation, { data, loading, error }] = useCreateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateProfileMutation, CreateProfileMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateProfileMutation, CreateProfileMutationVariables>(CreateProfileDocument, baseOptions);
      }
export type CreateProfileMutationHookResult = ReturnType<typeof useCreateProfileMutation>;
export type CreateProfileMutationResult = ApolloReactCommon.MutationResult<CreateProfileMutation>;
export type CreateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateProfileMutation, CreateProfileMutationVariables>;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($input: UpdateProfileInput!) {
  updateProfile(input: $input) {
    ...FullProfile
  }
}
    ${FullProfileFragmentDoc}`;
export type UpdateProfileMutationFn = ApolloReactCommon.MutationFunction<UpdateProfileMutation, UpdateProfileMutationVariables>;

/**
 * __useUpdateProfileMutation__
 *
 * To run a mutation, you first call `useUpdateProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProfileMutation, { data, loading, error }] = useUpdateProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProfileMutation, UpdateProfileMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateProfileMutation, UpdateProfileMutationVariables>(UpdateProfileDocument, baseOptions);
      }
export type UpdateProfileMutationHookResult = ReturnType<typeof useUpdateProfileMutation>;
export type UpdateProfileMutationResult = ApolloReactCommon.MutationResult<UpdateProfileMutation>;
export type UpdateProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const ProfileScreenDocument = gql`
    query ProfileScreen($username: ID!) {
  profile(username: $username) {
    ...FullProfile
  }
}
    ${FullProfileFragmentDoc}`;

/**
 * __useProfileScreenQuery__
 *
 * To run a query within a React component, call `useProfileScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileScreenQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useProfileScreenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProfileScreenQuery, ProfileScreenQueryVariables>) {
        return ApolloReactHooks.useQuery<ProfileScreenQuery, ProfileScreenQueryVariables>(ProfileScreenDocument, baseOptions);
      }
export function useProfileScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProfileScreenQuery, ProfileScreenQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ProfileScreenQuery, ProfileScreenQueryVariables>(ProfileScreenDocument, baseOptions);
        }
export type ProfileScreenQueryHookResult = ReturnType<typeof useProfileScreenQuery>;
export type ProfileScreenLazyQueryHookResult = ReturnType<typeof useProfileScreenLazyQuery>;
export type ProfileScreenQueryResult = ApolloReactCommon.QueryResult<ProfileScreenQuery, ProfileScreenQueryVariables>;
export const AcceptBidDocument = gql`
    mutation AcceptBid($rfpId: ID!, $rfpVersion: Int!, $bidId: ID!) {
  updateRFP(input: {id: $rfpId, expectedVersion: $rfpVersion, acceptedBidId: $bidId}) {
    id
    version
    acceptedBidId
  }
}
    `;
export type AcceptBidMutationFn = ApolloReactCommon.MutationFunction<AcceptBidMutation, AcceptBidMutationVariables>;

/**
 * __useAcceptBidMutation__
 *
 * To run a mutation, you first call `useAcceptBidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptBidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptBidMutation, { data, loading, error }] = useAcceptBidMutation({
 *   variables: {
 *      rfpId: // value for 'rfpId'
 *      rfpVersion: // value for 'rfpVersion'
 *      bidId: // value for 'bidId'
 *   },
 * });
 */
export function useAcceptBidMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcceptBidMutation, AcceptBidMutationVariables>) {
        return ApolloReactHooks.useMutation<AcceptBidMutation, AcceptBidMutationVariables>(AcceptBidDocument, baseOptions);
      }
export type AcceptBidMutationHookResult = ReturnType<typeof useAcceptBidMutation>;
export type AcceptBidMutationResult = ApolloReactCommon.MutationResult<AcceptBidMutation>;
export type AcceptBidMutationOptions = ApolloReactCommon.BaseMutationOptions<AcceptBidMutation, AcceptBidMutationVariables>;
export const ApproveMeasurementsDocument = gql`
    mutation ApproveMeasurements($rfpId: ID!, $rfpVersion: Int!) {
  updateRFP(input: {id: $rfpId, expectedVersion: $rfpVersion, state: OPEN}) {
    id
    version
    state
  }
}
    `;
export type ApproveMeasurementsMutationFn = ApolloReactCommon.MutationFunction<ApproveMeasurementsMutation, ApproveMeasurementsMutationVariables>;

/**
 * __useApproveMeasurementsMutation__
 *
 * To run a mutation, you first call `useApproveMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveMeasurementsMutation, { data, loading, error }] = useApproveMeasurementsMutation({
 *   variables: {
 *      rfpId: // value for 'rfpId'
 *      rfpVersion: // value for 'rfpVersion'
 *   },
 * });
 */
export function useApproveMeasurementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ApproveMeasurementsMutation, ApproveMeasurementsMutationVariables>) {
        return ApolloReactHooks.useMutation<ApproveMeasurementsMutation, ApproveMeasurementsMutationVariables>(ApproveMeasurementsDocument, baseOptions);
      }
export type ApproveMeasurementsMutationHookResult = ReturnType<typeof useApproveMeasurementsMutation>;
export type ApproveMeasurementsMutationResult = ApolloReactCommon.MutationResult<ApproveMeasurementsMutation>;
export type ApproveMeasurementsMutationOptions = ApolloReactCommon.BaseMutationOptions<ApproveMeasurementsMutation, ApproveMeasurementsMutationVariables>;
export const StartBidPaymentDocument = gql`
    mutation StartBidPayment($bidId: ID!, $description: String) {
  startStripeCheckoutSessionForBid(bidId: $bidId, description: $description) {
    sessionId
  }
}
    `;
export type StartBidPaymentMutationFn = ApolloReactCommon.MutationFunction<StartBidPaymentMutation, StartBidPaymentMutationVariables>;

/**
 * __useStartBidPaymentMutation__
 *
 * To run a mutation, you first call `useStartBidPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBidPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBidPaymentMutation, { data, loading, error }] = useStartBidPaymentMutation({
 *   variables: {
 *      bidId: // value for 'bidId'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useStartBidPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartBidPaymentMutation, StartBidPaymentMutationVariables>) {
        return ApolloReactHooks.useMutation<StartBidPaymentMutation, StartBidPaymentMutationVariables>(StartBidPaymentDocument, baseOptions);
      }
export type StartBidPaymentMutationHookResult = ReturnType<typeof useStartBidPaymentMutation>;
export type StartBidPaymentMutationResult = ApolloReactCommon.MutationResult<StartBidPaymentMutation>;
export type StartBidPaymentMutationOptions = ApolloReactCommon.BaseMutationOptions<StartBidPaymentMutation, StartBidPaymentMutationVariables>;
export const CreateOrLinkUserDocument = gql`
    mutation CreateOrLinkUser {
  createOrLinkUser {
    username
    token
  }
}
    `;
export type CreateOrLinkUserMutationFn = ApolloReactCommon.MutationFunction<CreateOrLinkUserMutation, CreateOrLinkUserMutationVariables>;

/**
 * __useCreateOrLinkUserMutation__
 *
 * To run a mutation, you first call `useCreateOrLinkUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrLinkUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrLinkUserMutation, { data, loading, error }] = useCreateOrLinkUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateOrLinkUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrLinkUserMutation, CreateOrLinkUserMutationVariables>) {
        return ApolloReactHooks.useMutation<CreateOrLinkUserMutation, CreateOrLinkUserMutationVariables>(CreateOrLinkUserDocument, baseOptions);
      }
export type CreateOrLinkUserMutationHookResult = ReturnType<typeof useCreateOrLinkUserMutation>;
export type CreateOrLinkUserMutationResult = ApolloReactCommon.MutationResult<CreateOrLinkUserMutation>;
export type CreateOrLinkUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrLinkUserMutation, CreateOrLinkUserMutationVariables>;
export const ServiceContractsDocument = gql`
    query ServiceContracts($propertyId: ID!, $serviceType: ServiceType!) {
  serviceContractsForProperty(propertyId: $propertyId, typeStart: {beginsWith: {type: $serviceType}}, sortDirection: DESC, limit: 1) {
    items {
      ...FullServiceContract
    }
    nextToken
  }
}
    ${FullServiceContractFragmentDoc}`;

/**
 * __useServiceContractsQuery__
 *
 * To run a query within a React component, call `useServiceContractsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceContractsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceContractsQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      serviceType: // value for 'serviceType'
 *   },
 * });
 */
export function useServiceContractsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ServiceContractsQuery, ServiceContractsQueryVariables>) {
        return ApolloReactHooks.useQuery<ServiceContractsQuery, ServiceContractsQueryVariables>(ServiceContractsDocument, baseOptions);
      }
export function useServiceContractsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ServiceContractsQuery, ServiceContractsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<ServiceContractsQuery, ServiceContractsQueryVariables>(ServiceContractsDocument, baseOptions);
        }
export type ServiceContractsQueryHookResult = ReturnType<typeof useServiceContractsQuery>;
export type ServiceContractsLazyQueryHookResult = ReturnType<typeof useServiceContractsLazyQuery>;
export type ServiceContractsQueryResult = ApolloReactCommon.QueryResult<ServiceContractsQuery, ServiceContractsQueryVariables>;
export const UpdateMeasurementsDocument = gql`
    mutation UpdateMeasurements($input: UpdateMeasurementsInput!) {
  updateMeasurements(input: $input) {
    ...FullMeasurements
  }
}
    ${FullMeasurementsFragmentDoc}`;
export type UpdateMeasurementsMutationFn = ApolloReactCommon.MutationFunction<UpdateMeasurementsMutation, UpdateMeasurementsMutationVariables>;

/**
 * __useUpdateMeasurementsMutation__
 *
 * To run a mutation, you first call `useUpdateMeasurementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeasurementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeasurementsMutation, { data, loading, error }] = useUpdateMeasurementsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeasurementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMeasurementsMutation, UpdateMeasurementsMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateMeasurementsMutation, UpdateMeasurementsMutationVariables>(UpdateMeasurementsDocument, baseOptions);
      }
export type UpdateMeasurementsMutationHookResult = ReturnType<typeof useUpdateMeasurementsMutation>;
export type UpdateMeasurementsMutationResult = ApolloReactCommon.MutationResult<UpdateMeasurementsMutation>;
export type UpdateMeasurementsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateMeasurementsMutation, UpdateMeasurementsMutationVariables>;
export const UpdateExpensesDocument = gql`
    mutation UpdateExpenses($input: UpdateExpensesInput!) {
  updateExpenses(input: $input) {
    ...FullExpenses
  }
}
    ${FullExpensesFragmentDoc}`;
export type UpdateExpensesMutationFn = ApolloReactCommon.MutationFunction<UpdateExpensesMutation, UpdateExpensesMutationVariables>;

/**
 * __useUpdateExpensesMutation__
 *
 * To run a mutation, you first call `useUpdateExpensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExpensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExpensesMutation, { data, loading, error }] = useUpdateExpensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExpensesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateExpensesMutation, UpdateExpensesMutationVariables>) {
        return ApolloReactHooks.useMutation<UpdateExpensesMutation, UpdateExpensesMutationVariables>(UpdateExpensesDocument, baseOptions);
      }
export type UpdateExpensesMutationHookResult = ReturnType<typeof useUpdateExpensesMutation>;
export type UpdateExpensesMutationResult = ApolloReactCommon.MutationResult<UpdateExpensesMutation>;
export type UpdateExpensesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateExpensesMutation, UpdateExpensesMutationVariables>;